export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: any;
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { [key: string]: any };
  /**
   * A JSON Web Token defined by [RFC 7519](https://tools.ietf.org/html/rfc7519)
   * which securely represents claims between two parties.
   */
  JwtToken: any;
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: string;
};

/** All input for the `attendeeAttachmentDelete` mutation. */
export type AttendeeAttachmentDeleteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  attendeeId: Scalars['UUID'];
  id: Scalars['Int'];
};

/** The output of our `attendeeAttachmentDelete` mutation. */
export type AttendeeAttachmentDeletePayload = {
  __typename?: 'AttendeeAttachmentDeletePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  upload?: Maybe<Upload>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `attendeeAttachmentUploadComplete` mutation. */
export type AttendeeAttachmentUploadCompleteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  attendeeId: Scalars['UUID'];
  src: Scalars['String'];
};

/** The output of our `attendeeAttachmentUploadComplete` mutation. */
export type AttendeeAttachmentUploadCompletePayload = {
  __typename?: 'AttendeeAttachmentUploadCompletePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  upload?: Maybe<Upload>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `attendeeAttachmentUploadStart` mutation. */
export type AttendeeAttachmentUploadStartInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  attendeeId: Scalars['UUID'];
  size: Scalars['Int'];
  type: Scalars['String'];
  name: Scalars['String'];
};

/** The output of our `attendeeAttachmentUploadStart` mutation. */
export type AttendeeAttachmentUploadStartPayload = {
  __typename?: 'AttendeeAttachmentUploadStartPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type AttendeeComingSession = Node & {
  __typename?: 'AttendeeComingSession';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['Int'];
  startedAt?: Maybe<Scalars['Datetime']>;
  stoppedAt?: Maybe<Scalars['Datetime']>;
  topicId?: Maybe<Scalars['Int']>;
  /** Reads a single `AttendeeItem` that is related to this `AttendeeComingSession`. */
  topic?: Maybe<AttendeeItem>;
};

/** A connection to a list of `AttendeeComingSession` values. */
export type AttendeeComingSessionsConnection = {
  __typename?: 'AttendeeComingSessionsConnection';
  /** A list of `AttendeeComingSession` objects. */
  nodes: Array<Maybe<AttendeeComingSession>>;
  /** A list of edges which contains the `AttendeeComingSession` and cursor to aid in pagination. */
  edges: Array<AttendeeComingSessionsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AttendeeComingSession` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AttendeeComingSession` edge in the connection. */
export type AttendeeComingSessionsEdge = {
  __typename?: 'AttendeeComingSessionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AttendeeComingSession` at the end of the edge. */
  node?: Maybe<AttendeeComingSession>;
};

export type AttendeeForumTopic = Node & {
  __typename?: 'AttendeeForumTopic';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['Int'];
  courseId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  pinnedAt?: Maybe<Scalars['Datetime']>;
  hidden?: Maybe<Scalars['Boolean']>;
  restricted?: Maybe<Scalars['Boolean']>;
  readonly?: Maybe<Scalars['Boolean']>;
  reverse?: Maybe<Scalars['Boolean']>;
  lastPostAt?: Maybe<Scalars['Datetime']>;
  name?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  posts?: Maybe<Scalars['JSON']>;
};

/** All input for the `attendeeGuestSignupCodeJoin` mutation. */
export type AttendeeGuestSignupCodeJoinInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  signupCode: Scalars['String'];
};

/** The output of our `attendeeGuestSignupCodeJoin` mutation. */
export type AttendeeGuestSignupCodeJoinPayload = {
  __typename?: 'AttendeeGuestSignupCodeJoinPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  sessionAttendee?: Maybe<SessionAttendee>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Session` that is related to this `SessionAttendee`. */
  session?: Maybe<Session>;
  /** An edge for our `SessionAttendee`. May be used by Relay 1. */
  sessionAttendeeEdge?: Maybe<SessionAttendeesEdge>;
};


/** The output of our `attendeeGuestSignupCodeJoin` mutation. */
export type AttendeeGuestSignupCodeJoinPayloadSessionAttendeeEdgeArgs = {
  orderBy?: Maybe<Array<SessionAttendeesOrderBy>>;
};

export type AttendeeItem = Node & {
  __typename?: 'AttendeeItem';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['Int'];
  path?: Maybe<Scalars['String']>;
  personId?: Maybe<Scalars['Int']>;
  type?: Maybe<ItemType>;
  typeTopic?: Maybe<ItemTypeTopic>;
  courseId?: Maybe<Scalars['Int']>;
  courseTopicPublic?: Maybe<Scalars['Boolean']>;
  courseSignupCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  deletedAt?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameSearch?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  /** Reads a single `AttendeeItem` that is related to this `AttendeeItem`. */
  course?: Maybe<AttendeeItem>;
  /** Reads and enables pagination through a set of `AttendeeItem`. */
  attendeeItemsByCourseId: AttendeeItemsConnection;
  dataCoverImageUrl?: Maybe<Scalars['JSON']>;
  dataGradebook?: Maybe<Scalars['JSON']>;
  ownerPublicProfile?: Maybe<PersonPublicProfile>;
  /** Reads and enables pagination through a set of `PersonPublicProfile`. */
  presenters: PersonPublicProfilesConnection;
  /** Reads and enables pagination through a set of `Session`. */
  sessions: SessionsConnection;
};


export type AttendeeItemAttendeeItemsByCourseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<AttendeeItemsOrderBy>>;
  filter?: Maybe<AttendeeItemFilter>;
};


export type AttendeeItemPresentersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


export type AttendeeItemSessionsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<SessionCondition>;
  filter?: Maybe<SessionFilter>;
};

/** A filter to be used against `AttendeeItem` object types. All fields are combined with a logical ‘and.’ */
export type AttendeeItemFilter = {
  /** Filter by the object’s `attendeeItemsByCourseId` relation. */
  attendeeItemsByCourseId?: Maybe<AttendeeItemToManyAttendeeItemFilter>;
  /** Some related `attendeeItemsByCourseId` exist. */
  attendeeItemsByCourseIdExist?: Maybe<Scalars['Boolean']>;
  /** Filter by the object’s `course` relation. */
  course?: Maybe<AttendeeItemFilter>;
  /** A related `course` exists. */
  courseExists?: Maybe<Scalars['Boolean']>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<AttendeeItemFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<AttendeeItemFilter>>;
  /** Negates the expression. */
  not?: Maybe<AttendeeItemFilter>;
};

/** A filter to be used against many `AttendeeItem` object types. All fields are combined with a logical ‘and.’ */
export type AttendeeItemToManyAttendeeItemFilter = {
  /** Every related `AttendeeItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: Maybe<AttendeeItemFilter>;
  /** Some related `AttendeeItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: Maybe<AttendeeItemFilter>;
  /** No related `AttendeeItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: Maybe<AttendeeItemFilter>;
};

/** A connection to a list of `AttendeeItem` values. */
export type AttendeeItemsConnection = {
  __typename?: 'AttendeeItemsConnection';
  /** A list of `AttendeeItem` objects. */
  nodes: Array<Maybe<AttendeeItem>>;
  /** A list of edges which contains the `AttendeeItem` and cursor to aid in pagination. */
  edges: Array<AttendeeItemsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AttendeeItem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AttendeeItem` edge in the connection. */
export type AttendeeItemsEdge = {
  __typename?: 'AttendeeItemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AttendeeItem` at the end of the edge. */
  node?: Maybe<AttendeeItem>;
};

/** Methods to use when ordering `AttendeeItem`. */
export enum AttendeeItemsOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `attendeeResponseCreate` mutation. */
export type AttendeeResponseCreateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  sessionId: Scalars['Int'];
};

/** The output of our `attendeeResponseCreate` mutation. */
export type AttendeeResponseCreatePayload = {
  __typename?: 'AttendeeResponseCreatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  sessionAttendee?: Maybe<SessionAttendee>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Session` that is related to this `SessionAttendee`. */
  session?: Maybe<Session>;
  /** An edge for our `SessionAttendee`. May be used by Relay 1. */
  sessionAttendeeEdge?: Maybe<SessionAttendeesEdge>;
};


/** The output of our `attendeeResponseCreate` mutation. */
export type AttendeeResponseCreatePayloadSessionAttendeeEdgeArgs = {
  orderBy?: Maybe<Array<SessionAttendeesOrderBy>>;
};

/** All input for the `attendeeSignupCodeJoinCourse` mutation. */
export type AttendeeSignupCodeJoinCourseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
};

/** The output of our `attendeeSignupCodeJoinCourse` mutation. */
export type AttendeeSignupCodeJoinCoursePayload = {
  __typename?: 'AttendeeSignupCodeJoinCoursePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  integer?: Maybe<Scalars['Int']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `attendeeSignupCodeJoinGroup` mutation. */
export type AttendeeSignupCodeJoinGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
};

/** The output of our `attendeeSignupCodeJoinGroup` mutation. */
export type AttendeeSignupCodeJoinGroupPayload = {
  __typename?: 'AttendeeSignupCodeJoinGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  integer?: Maybe<Scalars['Int']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `attendeeSignupCodeJoinSession` mutation. */
export type AttendeeSignupCodeJoinSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
};

/** The output of our `attendeeSignupCodeJoinSession` mutation. */
export type AttendeeSignupCodeJoinSessionPayload = {
  __typename?: 'AttendeeSignupCodeJoinSessionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  sessionAttendee?: Maybe<SessionAttendee>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Session` that is related to this `SessionAttendee`. */
  session?: Maybe<Session>;
  /** An edge for our `SessionAttendee`. May be used by Relay 1. */
  sessionAttendeeEdge?: Maybe<SessionAttendeesEdge>;
};


/** The output of our `attendeeSignupCodeJoinSession` mutation. */
export type AttendeeSignupCodeJoinSessionPayloadSessionAttendeeEdgeArgs = {
  orderBy?: Maybe<Array<SessionAttendeesOrderBy>>;
};

export type AuthCode = {
  __typename?: 'AuthCode';
  action: Scalars['String'];
  value: Scalars['String'];
  code: Scalars['String'];
  validTime: Scalars['Datetime'];
};

export type Contact = Node & {
  __typename?: 'Contact';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['Int'];
  personId: Scalars['Int'];
  contactPersonId?: Maybe<Scalars['Int']>;
  contactEmailHash?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nameSearch: Scalars['String'];
  contactGroups: Scalars['JSON'];
  contactEmailMask?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Person` that is related to this `Contact`. */
  person?: Maybe<Person>;
  contactPersonPublicProfile?: Maybe<PersonPublicProfile>;
};

/** A condition to be used against `Contact` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ContactCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `contactPersonId` field. */
  contactPersonId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `nameSearch` field. */
  nameSearch?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `contactGroups` field. */
  contactGroups?: Maybe<Scalars['JSON']>;
};

/** A filter to be used against `Contact` object types. All fields are combined with a logical ‘and.’ */
export type ContactFilter = {
  /** Filter by the object’s `id` field. */
  id?: Maybe<IntFilter>;
  /** Filter by the object’s `personId` field. */
  personId?: Maybe<IntFilter>;
  /** Filter by the object’s `contactPersonId` field. */
  contactPersonId?: Maybe<IntFilter>;
  /** Filter by the object’s `nameSearch` field. */
  nameSearch?: Maybe<StringFilter>;
  /** Filter by the object’s `person` relation. */
  person?: Maybe<PersonFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<ContactFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<ContactFilter>>;
  /** Negates the expression. */
  not?: Maybe<ContactFilter>;
};

export type ContactGroup = Node & {
  __typename?: 'ContactGroup';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['Int'];
  personId: Scalars['Int'];
  name: Scalars['String'];
  archivedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Person` that is related to this `ContactGroup`. */
  person?: Maybe<Person>;
  size?: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `ContactGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ContactGroupCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: Maybe<Scalars['Int']>;
};

/** A filter to be used against `ContactGroup` object types. All fields are combined with a logical ‘and.’ */
export type ContactGroupFilter = {
  /** Filter by the object’s `id` field. */
  id?: Maybe<IntFilter>;
  /** Filter by the object’s `personId` field. */
  personId?: Maybe<IntFilter>;
  /** Filter by the object’s `person` relation. */
  person?: Maybe<PersonFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<ContactGroupFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<ContactGroupFilter>>;
  /** Negates the expression. */
  not?: Maybe<ContactGroupFilter>;
};

/** An input for mutations affecting `ContactGroup` */
export type ContactGroupInput = {
  personId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

/** Represents an update to a `ContactGroup`. Fields that are set will be updated. */
export type ContactGroupPatch = {
  name?: Maybe<Scalars['String']>;
};

/** A connection to a list of `ContactGroup` values. */
export type ContactGroupsConnection = {
  __typename?: 'ContactGroupsConnection';
  /** A list of `ContactGroup` objects. */
  nodes: Array<Maybe<ContactGroup>>;
  /** A list of edges which contains the `ContactGroup` and cursor to aid in pagination. */
  edges: Array<ContactGroupsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContactGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ContactGroup` edge in the connection. */
export type ContactGroupsEdge = {
  __typename?: 'ContactGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ContactGroup` at the end of the edge. */
  node?: Maybe<ContactGroup>;
};

/** Methods to use when ordering `ContactGroup`. */
export enum ContactGroupsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** An input for mutations affecting `Contact` */
export type ContactInput = {
  contactEmailHash?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  contactEmailMask?: Maybe<Scalars['String']>;
};

/** Represents an update to a `Contact`. Fields that are set will be updated. */
export type ContactPatch = {
  name?: Maybe<Scalars['String']>;
  contactGroups?: Maybe<Scalars['JSON']>;
};

/** A connection to a list of `Contact` values. */
export type ContactsConnection = {
  __typename?: 'ContactsConnection';
  /** A list of `Contact` objects. */
  nodes: Array<Maybe<Contact>>;
  /** A list of edges which contains the `Contact` and cursor to aid in pagination. */
  edges: Array<ContactsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Contact` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Contact` edge in the connection. */
export type ContactsEdge = {
  __typename?: 'ContactsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Contact` at the end of the edge. */
  node?: Maybe<Contact>;
};

/** Methods to use when ordering `Contact`. */
export enum ContactsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  ContactPersonIdAsc = 'CONTACT_PERSON_ID_ASC',
  ContactPersonIdDesc = 'CONTACT_PERSON_ID_DESC',
  NameSearchAsc = 'NAME_SEARCH_ASC',
  NameSearchDesc = 'NAME_SEARCH_DESC',
  ContactGroupsAsc = 'CONTACT_GROUPS_ASC',
  ContactGroupsDesc = 'CONTACT_GROUPS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `createAttendeeFileDeleteJwt` mutation. */
export type CreateAttendeeFileDeleteJwtInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  attendeeId: Scalars['Int'];
  filePath: Scalars['String'];
};

/** The output of our `createAttendeeFileDeleteJwt` mutation. */
export type CreateAttendeeFileDeleteJwtPayload = {
  __typename?: 'CreateAttendeeFileDeleteJwtPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `createAttendeeFileUploadJwt` mutation. */
export type CreateAttendeeFileUploadJwtInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  attendeeId: Scalars['Int'];
  fileExt: Scalars['String'];
};

/** The output of our `createAttendeeFileUploadJwt` mutation. */
export type CreateAttendeeFileUploadJwtPayload = {
  __typename?: 'CreateAttendeeFileUploadJwtPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `ContactGroup` mutation. */
export type CreateContactGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ContactGroup` to be created by this mutation. */
  contactGroup: ContactGroupInput;
};

/** The output of our create `ContactGroup` mutation. */
export type CreateContactGroupPayload = {
  __typename?: 'CreateContactGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ContactGroup` that was created by this mutation. */
  contactGroup?: Maybe<ContactGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Person` that is related to this `ContactGroup`. */
  person?: Maybe<Person>;
  /** An edge for our `ContactGroup`. May be used by Relay 1. */
  contactGroupEdge?: Maybe<ContactGroupsEdge>;
};


/** The output of our create `ContactGroup` mutation. */
export type CreateContactGroupPayloadContactGroupEdgeArgs = {
  orderBy?: Maybe<Array<ContactGroupsOrderBy>>;
};

/** All input for the create `Contact` mutation. */
export type CreateContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Contact` to be created by this mutation. */
  contact: ContactInput;
};

/** The output of our create `Contact` mutation. */
export type CreateContactPayload = {
  __typename?: 'CreateContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Contact` that was created by this mutation. */
  contact?: Maybe<Contact>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Person` that is related to this `Contact`. */
  person?: Maybe<Person>;
  /** An edge for our `Contact`. May be used by Relay 1. */
  contactEdge?: Maybe<ContactsEdge>;
};


/** The output of our create `Contact` mutation. */
export type CreateContactPayloadContactEdgeArgs = {
  orderBy?: Maybe<Array<ContactsOrderBy>>;
};

/** All input for the create `ForumPersonActivity` mutation. */
export type CreateForumPersonActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ForumPersonActivity` to be created by this mutation. */
  forumPersonActivity: ForumPersonActivityInput;
};

/** The output of our create `ForumPersonActivity` mutation. */
export type CreateForumPersonActivityPayload = {
  __typename?: 'CreateForumPersonActivityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ForumPersonActivity` that was created by this mutation. */
  forumPersonActivity?: Maybe<ForumPersonActivity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Person` that is related to this `ForumPersonActivity`. */
  person?: Maybe<Person>;
  /** An edge for our `ForumPersonActivity`. May be used by Relay 1. */
  forumPersonActivityEdge?: Maybe<ForumPersonActivitiesEdge>;
};


/** The output of our create `ForumPersonActivity` mutation. */
export type CreateForumPersonActivityPayloadForumPersonActivityEdgeArgs = {
  orderBy?: Maybe<Array<ForumPersonActivitiesOrderBy>>;
};

/** All input for the create `ForumTopic` mutation. */
export type CreateForumTopicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ForumTopic` to be created by this mutation. */
  forumTopic: ForumTopicInput;
};

/** The output of our create `ForumTopic` mutation. */
export type CreateForumTopicPayload = {
  __typename?: 'CreateForumTopicPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ForumTopic` that was created by this mutation. */
  forumTopic?: Maybe<ForumTopic>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `ForumTopic`. */
  course?: Maybe<Item>;
  /** An edge for our `ForumTopic`. May be used by Relay 1. */
  forumTopicEdge?: Maybe<ForumTopicsEdge>;
};


/** The output of our create `ForumTopic` mutation. */
export type CreateForumTopicPayloadForumTopicEdgeArgs = {
  orderBy?: Maybe<Array<ForumTopicsOrderBy>>;
};

/** All input for the `createForumTopicStudentGroup` mutation. */
export type CreateForumTopicStudentGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  forumTopicId: Scalars['Int'];
  studentGroupId: Scalars['Int'];
  courseId: Scalars['Int'];
};

/** The output of our `createForumTopicStudentGroup` mutation. */
export type CreateForumTopicStudentGroupPayload = {
  __typename?: 'CreateForumTopicStudentGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `createItemDuplicate` mutation. */
export type CreateItemDuplicateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  parentId: Scalars['Int'];
};

/** The output of our `createItemDuplicate` mutation. */
export type CreateItemDuplicatePayload = {
  __typename?: 'CreateItemDuplicatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  item?: Maybe<Item>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `Item`. */
  course?: Maybe<Item>;
  /** An edge for our `Item`. May be used by Relay 1. */
  itemEdge?: Maybe<ItemsEdge>;
};


/** The output of our `createItemDuplicate` mutation. */
export type CreateItemDuplicatePayloadItemEdgeArgs = {
  orderBy?: Maybe<Array<ItemsOrderBy>>;
};

/** All input for the `createItemFileDeleteJwt` mutation. */
export type CreateItemFileDeleteJwtInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  itemId: Scalars['Int'];
  filePath: Scalars['String'];
};

/** The output of our `createItemFileDeleteJwt` mutation. */
export type CreateItemFileDeleteJwtPayload = {
  __typename?: 'CreateItemFileDeleteJwtPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `createItemFileUploadJwt` mutation. */
export type CreateItemFileUploadJwtInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  itemId: Scalars['Int'];
  fileExt: Scalars['String'];
};

/** The output of our `createItemFileUploadJwt` mutation. */
export type CreateItemFileUploadJwtPayload = {
  __typename?: 'CreateItemFileUploadJwtPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `createItem` mutation. */
export type CreateItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['Int']>;
  type?: Maybe<ItemType>;
  typeTopic?: Maybe<ItemTypeTopic>;
  name?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
};

/** The output of our `createItem` mutation. */
export type CreateItemPayload = {
  __typename?: 'CreateItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  item?: Maybe<Item>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `Item`. */
  course?: Maybe<Item>;
  /** An edge for our `Item`. May be used by Relay 1. */
  itemEdge?: Maybe<ItemsEdge>;
};


/** The output of our `createItem` mutation. */
export type CreateItemPayloadItemEdgeArgs = {
  orderBy?: Maybe<Array<ItemsOrderBy>>;
};

/** All input for the `createItemShare` mutation. */
export type CreateItemShareInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  personId: Scalars['Int'];
  role: ItemShareRole;
};

/** The output of our `createItemShare` mutation. */
export type CreateItemSharePayload = {
  __typename?: 'CreateItemSharePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  itemShare?: Maybe<ItemShare>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `ItemShare`. */
  itemByPath?: Maybe<Item>;
  /** Reads a single `Person` that is related to this `ItemShare`. */
  person?: Maybe<Person>;
  /** An edge for our `ItemShare`. May be used by Relay 1. */
  itemShareEdge?: Maybe<ItemSharesEdge>;
};

/** All input for the `createPersonFileDeleteJwt` mutation. */
export type CreatePersonFileDeleteJwtInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  filePath: Scalars['String'];
};

/** The output of our `createPersonFileDeleteJwt` mutation. */
export type CreatePersonFileDeleteJwtPayload = {
  __typename?: 'CreatePersonFileDeleteJwtPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `createPersonFileUploadJwt` mutation. */
export type CreatePersonFileUploadJwtInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  fileExt: Scalars['String'];
};

/** The output of our `createPersonFileUploadJwt` mutation. */
export type CreatePersonFileUploadJwtPayload = {
  __typename?: 'CreatePersonFileUploadJwtPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `Session` mutation. */
export type CreateSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Session` to be created by this mutation. */
  session: SessionInput;
};

/** The output of our create `Session` mutation. */
export type CreateSessionPayload = {
  __typename?: 'CreateSessionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Session` that was created by this mutation. */
  session?: Maybe<Session>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `Session`. */
  topic?: Maybe<Item>;
  /** Reads a single `StudentGroup` that is related to this `Session`. */
  studentGroup?: Maybe<StudentGroup>;
  /** An edge for our `Session`. May be used by Relay 1. */
  sessionEdge?: Maybe<SessionsEdge>;
};


/** The output of our create `Session` mutation. */
export type CreateSessionPayloadSessionEdgeArgs = {
  orderBy?: Maybe<Array<SessionsOrderBy>>;
};

/** All input for the `createSessionProjectorAuthCode` mutation. */
export type CreateSessionProjectorAuthCodeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  sessionId: Scalars['Int'];
};

/** The output of our `createSessionProjectorAuthCode` mutation. */
export type CreateSessionProjectorAuthCodePayload = {
  __typename?: 'CreateSessionProjectorAuthCodePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  authCode?: Maybe<AuthCode>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `StudentGroup` mutation. */
export type CreateStudentGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `StudentGroup` to be created by this mutation. */
  studentGroup: StudentGroupInput;
};

/** The output of our create `StudentGroup` mutation. */
export type CreateStudentGroupPayload = {
  __typename?: 'CreateStudentGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `StudentGroup` that was created by this mutation. */
  studentGroup?: Maybe<StudentGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `StudentGroup`. May be used by Relay 1. */
  studentGroupEdge?: Maybe<StudentGroupsEdge>;
};

/** All input for the `createStudent` mutation. */
export type CreateStudentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  personId?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  studentGroupId?: Maybe<Scalars['Int']>;
};

/** The output of our `createStudent` mutation. */
export type CreateStudentPayload = {
  __typename?: 'CreateStudentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  student?: Maybe<Student>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `Student`. */
  course?: Maybe<Item>;
  /** Reads a single `StudentGroup` that is related to this `Student`. */
  studentGroup?: Maybe<StudentGroup>;
  /** An edge for our `Student`. May be used by Relay 1. */
  studentEdge?: Maybe<StudentsEdge>;
};


/** The output of our `createStudent` mutation. */
export type CreateStudentPayloadStudentEdgeArgs = {
  orderBy?: Maybe<Array<StudentsOrderBy>>;
};



/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<Scalars['Datetime']>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<Scalars['Datetime']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<Scalars['Datetime']>;
};

/** All input for the `deleteContactByNodeId` mutation. */
export type DeleteContactByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Contact` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteContactByPersonIdAndContactEmailHash` mutation. */
export type DeleteContactByPersonIdAndContactEmailHashInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  personId: Scalars['Int'];
  contactEmailHash: Scalars['String'];
};

/** All input for the `deleteContactByPersonIdAndContactPersonId` mutation. */
export type DeleteContactByPersonIdAndContactPersonIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  personId: Scalars['Int'];
  contactPersonId: Scalars['Int'];
};

/** All input for the `deleteContactGroupByNodeId` mutation. */
export type DeleteContactGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ContactGroup` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteContactGroupByPersonIdAndName` mutation. */
export type DeleteContactGroupByPersonIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  personId: Scalars['Int'];
  name: Scalars['String'];
};

/** All input for the `deleteContactGroup` mutation. */
export type DeleteContactGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `ContactGroup` mutation. */
export type DeleteContactGroupPayload = {
  __typename?: 'DeleteContactGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ContactGroup` that was deleted by this mutation. */
  contactGroup?: Maybe<ContactGroup>;
  deletedContactGroupNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Person` that is related to this `ContactGroup`. */
  person?: Maybe<Person>;
  /** An edge for our `ContactGroup`. May be used by Relay 1. */
  contactGroupEdge?: Maybe<ContactGroupsEdge>;
};


/** The output of our delete `ContactGroup` mutation. */
export type DeleteContactGroupPayloadContactGroupEdgeArgs = {
  orderBy?: Maybe<Array<ContactGroupsOrderBy>>;
};

/** All input for the `deleteContact` mutation. */
export type DeleteContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Contact` mutation. */
export type DeleteContactPayload = {
  __typename?: 'DeleteContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Contact` that was deleted by this mutation. */
  contact?: Maybe<Contact>;
  deletedContactNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Person` that is related to this `Contact`. */
  person?: Maybe<Person>;
  /** An edge for our `Contact`. May be used by Relay 1. */
  contactEdge?: Maybe<ContactsEdge>;
};


/** The output of our delete `Contact` mutation. */
export type DeleteContactPayloadContactEdgeArgs = {
  orderBy?: Maybe<Array<ContactsOrderBy>>;
};

/** All input for the `deleteForumTopicByIdAndCourseId` mutation. */
export type DeleteForumTopicByIdAndCourseIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  courseId: Scalars['Int'];
};

/** All input for the `deleteForumTopicByNodeId` mutation. */
export type DeleteForumTopicByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ForumTopic` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteForumTopic` mutation. */
export type DeleteForumTopicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `ForumTopic` mutation. */
export type DeleteForumTopicPayload = {
  __typename?: 'DeleteForumTopicPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ForumTopic` that was deleted by this mutation. */
  forumTopic?: Maybe<ForumTopic>;
  deletedForumTopicNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `ForumTopic`. */
  course?: Maybe<Item>;
  /** An edge for our `ForumTopic`. May be used by Relay 1. */
  forumTopicEdge?: Maybe<ForumTopicsEdge>;
};


/** The output of our delete `ForumTopic` mutation. */
export type DeleteForumTopicPayloadForumTopicEdgeArgs = {
  orderBy?: Maybe<Array<ForumTopicsOrderBy>>;
};

/** All input for the `deleteForumTopicStudentGroupByNodeId` mutation. */
export type DeleteForumTopicStudentGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ForumTopicStudentGroup` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteForumTopicStudentGroup` mutation. */
export type DeleteForumTopicStudentGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  forumTopicId: Scalars['Int'];
  studentGroupId: Scalars['Int'];
};

/** The output of our delete `ForumTopicStudentGroup` mutation. */
export type DeleteForumTopicStudentGroupPayload = {
  __typename?: 'DeleteForumTopicStudentGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ForumTopicStudentGroup` that was deleted by this mutation. */
  forumTopicStudentGroup?: Maybe<ForumTopicStudentGroup>;
  deletedForumTopicStudentGroupNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ForumTopic` that is related to this `ForumTopicStudentGroup`. */
  forumTopicByForumTopicIdAndCourseId?: Maybe<ForumTopic>;
  /** Reads a single `StudentGroup` that is related to this `ForumTopicStudentGroup`. */
  studentGroupByStudentGroupIdAndCourseId?: Maybe<StudentGroup>;
  /** An edge for our `ForumTopicStudentGroup`. May be used by Relay 1. */
  forumTopicStudentGroupEdge?: Maybe<ForumTopicStudentGroupsEdge>;
};


/** The output of our delete `ForumTopicStudentGroup` mutation. */
export type DeleteForumTopicStudentGroupPayloadForumTopicStudentGroupEdgeArgs = {
  orderBy?: Maybe<Array<ForumTopicStudentGroupsOrderBy>>;
};

/** All input for the `deleteItem` mutation. */
export type DeleteItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our `deleteItem` mutation. */
export type DeleteItemPayload = {
  __typename?: 'DeleteItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  item?: Maybe<Item>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `Item`. */
  course?: Maybe<Item>;
  /** An edge for our `Item`. May be used by Relay 1. */
  itemEdge?: Maybe<ItemsEdge>;
};


/** The output of our `deleteItem` mutation. */
export type DeleteItemPayloadItemEdgeArgs = {
  orderBy?: Maybe<Array<ItemsOrderBy>>;
};

/** All input for the `deleteItemShareByPathAndPersonId` mutation. */
export type DeleteItemShareByPathAndPersonIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  personId: Scalars['Int'];
};

/** The output of our delete `ItemShare` mutation. */
export type DeleteItemSharePayload = {
  __typename?: 'DeleteItemSharePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ItemShare` that was deleted by this mutation. */
  itemShare?: Maybe<ItemShare>;
  deletedItemShareNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `ItemShare`. */
  itemByPath?: Maybe<Item>;
  /** Reads a single `Person` that is related to this `ItemShare`. */
  person?: Maybe<Person>;
  /** An edge for our `ItemShare`. May be used by Relay 1. */
  itemShareEdge?: Maybe<ItemSharesEdge>;
};

/** All input for the `deletePersonOauthAccountByOauthProviderAndOauthId` mutation. */
export type DeletePersonOauthAccountByOauthProviderAndOauthIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  oauthProvider: PersonOauthProvider;
  oauthId: Scalars['String'];
};

/** The output of our delete `PersonOauthAccount` mutation. */
export type DeletePersonOauthAccountPayload = {
  __typename?: 'DeletePersonOauthAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PersonOauthAccount` that was deleted by this mutation. */
  personOauthAccount?: Maybe<PersonOauthAccount>;
  deletedPersonOauthAccountNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Person` that is related to this `PersonOauthAccount`. */
  person?: Maybe<Person>;
  /** An edge for our `PersonOauthAccount`. May be used by Relay 1. */
  personOauthAccountEdge?: Maybe<PersonOauthAccountsEdge>;
};


/** The output of our delete `PersonOauthAccount` mutation. */
export type DeletePersonOauthAccountPayloadPersonOauthAccountEdgeArgs = {
  orderBy?: Maybe<Array<PersonOauthAccountsOrderBy>>;
};

/** All input for the `deleteSession` mutation. */
export type DeleteSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our `deleteSession` mutation. */
export type DeleteSessionPayload = {
  __typename?: 'DeleteSessionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteStudentByNodeId` mutation. */
export type DeleteStudentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Student` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteStudentGroup` mutation. */
export type DeleteStudentGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our `deleteStudentGroup` mutation. */
export type DeleteStudentGroupPayload = {
  __typename?: 'DeleteStudentGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteStudent` mutation. */
export type DeleteStudentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Student` mutation. */
export type DeleteStudentPayload = {
  __typename?: 'DeleteStudentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Student` that was deleted by this mutation. */
  student?: Maybe<Student>;
  deletedStudentNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `Student`. */
  course?: Maybe<Item>;
  /** Reads a single `StudentGroup` that is related to this `Student`. */
  studentGroup?: Maybe<StudentGroup>;
  /** An edge for our `Student`. May be used by Relay 1. */
  studentEdge?: Maybe<StudentsEdge>;
};


/** The output of our delete `Student` mutation. */
export type DeleteStudentPayloadStudentEdgeArgs = {
  orderBy?: Maybe<Array<StudentsOrderBy>>;
};

/** A connection to a list of `ForumPersonActivity` values. */
export type ForumPersonActivitiesConnection = {
  __typename?: 'ForumPersonActivitiesConnection';
  /** A list of `ForumPersonActivity` objects. */
  nodes: Array<Maybe<ForumPersonActivity>>;
  /** A list of edges which contains the `ForumPersonActivity` and cursor to aid in pagination. */
  edges: Array<ForumPersonActivitiesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ForumPersonActivity` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ForumPersonActivity` edge in the connection. */
export type ForumPersonActivitiesEdge = {
  __typename?: 'ForumPersonActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ForumPersonActivity` at the end of the edge. */
  node?: Maybe<ForumPersonActivity>;
};

/** Methods to use when ordering `ForumPersonActivity`. */
export enum ForumPersonActivitiesOrderBy {
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type ForumPersonActivity = Node & {
  __typename?: 'ForumPersonActivity';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  personId: Scalars['Int'];
  lastPostRead: Scalars['JSON'];
  /** Reads a single `Person` that is related to this `ForumPersonActivity`. */
  person?: Maybe<Person>;
};

/**
 * A condition to be used against `ForumPersonActivity` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ForumPersonActivityCondition = {
  /** Checks for equality with the object’s `personId` field. */
  personId?: Maybe<Scalars['Int']>;
};

/** A filter to be used against `ForumPersonActivity` object types. All fields are combined with a logical ‘and.’ */
export type ForumPersonActivityFilter = {
  /** Filter by the object’s `personId` field. */
  personId?: Maybe<IntFilter>;
  /** Filter by the object’s `person` relation. */
  person?: Maybe<PersonFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<ForumPersonActivityFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<ForumPersonActivityFilter>>;
  /** Negates the expression. */
  not?: Maybe<ForumPersonActivityFilter>;
};

/** An input for mutations affecting `ForumPersonActivity` */
export type ForumPersonActivityInput = {
  personId: Scalars['Int'];
  lastPostRead?: Maybe<Scalars['JSON']>;
};

export type ForumTopic = Node & {
  __typename?: 'ForumTopic';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['Int'];
  courseId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  pinnedAt?: Maybe<Scalars['Datetime']>;
  hidden: Scalars['Boolean'];
  restricted: Scalars['Boolean'];
  readonly: Scalars['Boolean'];
  reverse: Scalars['Boolean'];
  lastPostAt?: Maybe<Scalars['Datetime']>;
  name: Scalars['String'];
  info?: Maybe<Scalars['String']>;
  /** Reads a single `Item` that is related to this `ForumTopic`. */
  course?: Maybe<Item>;
  /** Reads and enables pagination through a set of `ForumTopicStudentGroup`. */
  forumTopicStudentGroupsByForumTopicIdAndCourseId: ForumTopicStudentGroupsConnection;
  courseName?: Maybe<Scalars['String']>;
  lastPost?: Maybe<Scalars['JSON']>;
  lastPostAuthorPublicProfile?: Maybe<PersonPublicProfile>;
  posts?: Maybe<Scalars['JSON']>;
  totalPosts?: Maybe<Scalars['Int']>;
  totalPostsPersonRead?: Maybe<Scalars['Int']>;
};


export type ForumTopicForumTopicStudentGroupsByForumTopicIdAndCourseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ForumTopicStudentGroupsOrderBy>>;
  condition?: Maybe<ForumTopicStudentGroupCondition>;
  filter?: Maybe<ForumTopicStudentGroupFilter>;
};


export type ForumTopicPostsArgs = {
  start: Scalars['Int'];
  count: Scalars['Int'];
};

/**
 * A condition to be used against `ForumTopic` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ForumTopicCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `courseId` field. */
  courseId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: Maybe<Scalars['Datetime']>;
};

/** A filter to be used against `ForumTopic` object types. All fields are combined with a logical ‘and.’ */
export type ForumTopicFilter = {
  /** Filter by the object’s `id` field. */
  id?: Maybe<IntFilter>;
  /** Filter by the object’s `courseId` field. */
  courseId?: Maybe<IntFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `forumTopicStudentGroupsByForumTopicIdAndCourseId` relation. */
  forumTopicStudentGroupsByForumTopicIdAndCourseId?: Maybe<ForumTopicToManyForumTopicStudentGroupFilter>;
  /** Some related `forumTopicStudentGroupsByForumTopicIdAndCourseId` exist. */
  forumTopicStudentGroupsByForumTopicIdAndCourseIdExist?: Maybe<Scalars['Boolean']>;
  /** Filter by the object’s `course` relation. */
  course?: Maybe<ItemFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<ForumTopicFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<ForumTopicFilter>>;
  /** Negates the expression. */
  not?: Maybe<ForumTopicFilter>;
};

/** An input for mutations affecting `ForumTopic` */
export type ForumTopicInput = {
  courseId: Scalars['Int'];
  restricted?: Maybe<Scalars['Boolean']>;
  readonly?: Maybe<Scalars['Boolean']>;
  reverse?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  info?: Maybe<Scalars['String']>;
};

/** Represents an update to a `ForumTopic`. Fields that are set will be updated. */
export type ForumTopicPatch = {
  deletedAt?: Maybe<Scalars['Datetime']>;
  pinnedAt?: Maybe<Scalars['Datetime']>;
  hidden?: Maybe<Scalars['Boolean']>;
  restricted?: Maybe<Scalars['Boolean']>;
  readonly?: Maybe<Scalars['Boolean']>;
  reverse?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
};

/** All input for the `forumTopicPostEdit` mutation. */
export type ForumTopicPostEditInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  forumTopicId: Scalars['Int'];
  postId: Scalars['Int'];
  text: Scalars['String'];
};

/** The output of our `forumTopicPostEdit` mutation. */
export type ForumTopicPostEditPayload = {
  __typename?: 'ForumTopicPostEditPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `forumTopicPostSend` mutation. */
export type ForumTopicPostSendInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  forumTopicId: Scalars['Int'];
  text: Scalars['String'];
};

/** The output of our `forumTopicPostSend` mutation. */
export type ForumTopicPostSendPayload = {
  __typename?: 'ForumTopicPostSendPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `forumTopicPostSetHide` mutation. */
export type ForumTopicPostSetHideInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  forumTopicId: Scalars['Int'];
  postId: Scalars['Int'];
  hide: Scalars['Boolean'];
};

/** The output of our `forumTopicPostSetHide` mutation. */
export type ForumTopicPostSetHidePayload = {
  __typename?: 'ForumTopicPostSetHidePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type ForumTopicStudentGroup = Node & {
  __typename?: 'ForumTopicStudentGroup';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  forumTopicId: Scalars['Int'];
  studentGroupId: Scalars['Int'];
  courseId: Scalars['Int'];
  /** Reads a single `ForumTopic` that is related to this `ForumTopicStudentGroup`. */
  forumTopicByForumTopicIdAndCourseId?: Maybe<ForumTopic>;
  /** Reads a single `StudentGroup` that is related to this `ForumTopicStudentGroup`. */
  studentGroupByStudentGroupIdAndCourseId?: Maybe<StudentGroup>;
};

/**
 * A condition to be used against `ForumTopicStudentGroup` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ForumTopicStudentGroupCondition = {
  /** Checks for equality with the object’s `forumTopicId` field. */
  forumTopicId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `studentGroupId` field. */
  studentGroupId?: Maybe<Scalars['Int']>;
};

/** A filter to be used against `ForumTopicStudentGroup` object types. All fields are combined with a logical ‘and.’ */
export type ForumTopicStudentGroupFilter = {
  /** Filter by the object’s `forumTopicId` field. */
  forumTopicId?: Maybe<IntFilter>;
  /** Filter by the object’s `studentGroupId` field. */
  studentGroupId?: Maybe<IntFilter>;
  /** Filter by the object’s `forumTopicByForumTopicIdAndCourseId` relation. */
  forumTopicByForumTopicIdAndCourseId?: Maybe<ForumTopicFilter>;
  /** Filter by the object’s `studentGroupByStudentGroupIdAndCourseId` relation. */
  studentGroupByStudentGroupIdAndCourseId?: Maybe<StudentGroupFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<ForumTopicStudentGroupFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<ForumTopicStudentGroupFilter>>;
  /** Negates the expression. */
  not?: Maybe<ForumTopicStudentGroupFilter>;
};

/** A connection to a list of `ForumTopicStudentGroup` values. */
export type ForumTopicStudentGroupsConnection = {
  __typename?: 'ForumTopicStudentGroupsConnection';
  /** A list of `ForumTopicStudentGroup` objects. */
  nodes: Array<Maybe<ForumTopicStudentGroup>>;
  /** A list of edges which contains the `ForumTopicStudentGroup` and cursor to aid in pagination. */
  edges: Array<ForumTopicStudentGroupsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ForumTopicStudentGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ForumTopicStudentGroup` edge in the connection. */
export type ForumTopicStudentGroupsEdge = {
  __typename?: 'ForumTopicStudentGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ForumTopicStudentGroup` at the end of the edge. */
  node?: Maybe<ForumTopicStudentGroup>;
};

/** Methods to use when ordering `ForumTopicStudentGroup`. */
export enum ForumTopicStudentGroupsOrderBy {
  Natural = 'NATURAL',
  ForumTopicIdAsc = 'FORUM_TOPIC_ID_ASC',
  ForumTopicIdDesc = 'FORUM_TOPIC_ID_DESC',
  StudentGroupIdAsc = 'STUDENT_GROUP_ID_ASC',
  StudentGroupIdDesc = 'STUDENT_GROUP_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against many `ForumTopicStudentGroup` object types. All fields are combined with a logical ‘and.’ */
export type ForumTopicToManyForumTopicStudentGroupFilter = {
  /** Every related `ForumTopicStudentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: Maybe<ForumTopicStudentGroupFilter>;
  /** Some related `ForumTopicStudentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: Maybe<ForumTopicStudentGroupFilter>;
  /** No related `ForumTopicStudentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: Maybe<ForumTopicStudentGroupFilter>;
};

/** All input for the `forumTopicTrashEmpty` mutation. */
export type ForumTopicTrashEmptyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  courseId: Scalars['Int'];
};

/** The output of our `forumTopicTrashEmpty` mutation. */
export type ForumTopicTrashEmptyPayload = {
  __typename?: 'ForumTopicTrashEmptyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `ForumTopic` values. */
export type ForumTopicsConnection = {
  __typename?: 'ForumTopicsConnection';
  /** A list of `ForumTopic` objects. */
  nodes: Array<Maybe<ForumTopic>>;
  /** A list of edges which contains the `ForumTopic` and cursor to aid in pagination. */
  edges: Array<ForumTopicsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ForumTopic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ForumTopic` edge in the connection. */
export type ForumTopicsEdge = {
  __typename?: 'ForumTopicsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ForumTopic` at the end of the edge. */
  node?: Maybe<ForumTopic>;
};

/** Methods to use when ordering `ForumTopic`. */
export enum ForumTopicsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  CourseIdAsc = 'COURSE_ID_ASC',
  CourseIdDesc = 'COURSE_ID_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<Scalars['Int']>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<Scalars['Int']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<Scalars['Int']>;
};

export type Item = Node & {
  __typename?: 'Item';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['Int'];
  path: Scalars['String'];
  personId: Scalars['Int'];
  type: ItemType;
  typeTopic?: Maybe<ItemTypeTopic>;
  courseId?: Maybe<Scalars['Int']>;
  courseTopicPublic?: Maybe<Scalars['Boolean']>;
  courseSignupCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  name: Scalars['String'];
  nameSearch: Scalars['String'];
  data?: Maybe<Scalars['JSON']>;
  /** Reads a single `Item` that is related to this `Item`. */
  course?: Maybe<Item>;
  /** Reads and enables pagination through a set of `Item`. */
  itemsByCourseId: ItemsConnection;
  /** Reads and enables pagination through a set of `ItemShare`. */
  itemSharesByPath: ItemSharesConnection;
  /** Reads and enables pagination through a set of `Student`. */
  studentsByCourseId: StudentsConnection;
  /** Reads and enables pagination through a set of `Session`. */
  sessionsByTopicId: SessionsConnection;
  /** Reads and enables pagination through a set of `ForumTopic`. */
  forumTopicsByCourseId: ForumTopicsConnection;
  ancesstors?: Maybe<Array<Maybe<Scalars['String']>>>;
  canAuthEdit?: Maybe<Scalars['Boolean']>;
  dataCoverImageUrl?: Maybe<Scalars['JSON']>;
  dataGradebook?: Maybe<Scalars['JSON']>;
  isAuthAdmin?: Maybe<Scalars['Boolean']>;
  ownerPublicProfile?: Maybe<PersonPublicProfile>;
  parent?: Maybe<Item>;
};


export type ItemItemsByCourseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ItemsOrderBy>>;
  condition?: Maybe<ItemCondition>;
  filter?: Maybe<ItemFilter>;
};


export type ItemItemSharesByPathArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


export type ItemStudentsByCourseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<StudentsOrderBy>>;
  condition?: Maybe<StudentCondition>;
  filter?: Maybe<StudentFilter>;
};


export type ItemSessionsByTopicIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SessionsOrderBy>>;
  condition?: Maybe<SessionCondition>;
  filter?: Maybe<SessionFilter>;
};


export type ItemForumTopicsByCourseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ForumTopicsOrderBy>>;
  condition?: Maybe<ForumTopicCondition>;
  filter?: Maybe<ForumTopicFilter>;
};

export type ItemAttachment = {
  __typename?: 'ItemAttachment';
  id?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  type?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  src?: Maybe<Scalars['String']>;
};

/** All input for the `itemAttachmentDelete` mutation. */
export type ItemAttachmentDeleteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our `itemAttachmentDelete` mutation. */
export type ItemAttachmentDeletePayload = {
  __typename?: 'ItemAttachmentDeletePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  upload?: Maybe<Upload>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `itemAttachmentUploadComplete` mutation. */
export type ItemAttachmentUploadCompleteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  src: Scalars['String'];
};

/** The output of our `itemAttachmentUploadComplete` mutation. */
export type ItemAttachmentUploadCompletePayload = {
  __typename?: 'ItemAttachmentUploadCompletePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  upload?: Maybe<Upload>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `itemAttachmentUploadStart` mutation. */
export type ItemAttachmentUploadStartInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  itemId: Scalars['Int'];
  size: Scalars['Int'];
  type: Scalars['String'];
  name: Scalars['String'];
};

/** The output of our `itemAttachmentUploadStart` mutation. */
export type ItemAttachmentUploadStartPayload = {
  __typename?: 'ItemAttachmentUploadStartPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `ItemAttachment` values. */
export type ItemAttachmentsConnection = {
  __typename?: 'ItemAttachmentsConnection';
  /** A list of `ItemAttachment` objects. */
  nodes: Array<Maybe<ItemAttachment>>;
  /** A list of edges which contains the `ItemAttachment` and cursor to aid in pagination. */
  edges: Array<ItemAttachmentsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ItemAttachment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ItemAttachment` edge in the connection. */
export type ItemAttachmentsEdge = {
  __typename?: 'ItemAttachmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ItemAttachment` at the end of the edge. */
  node?: Maybe<ItemAttachment>;
};

/** All input for the `itemAttachmentsPaste` mutation. */
export type ItemAttachmentsPasteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  files: Scalars['JSON'];
};

/** The output of our `itemAttachmentsPaste` mutation. */
export type ItemAttachmentsPastePayload = {
  __typename?: 'ItemAttachmentsPastePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A condition to be used against `Item` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ItemCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `path` field. */
  path?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `type` field. */
  type?: Maybe<ItemType>;
  /** Checks for equality with the object’s `courseId` field. */
  courseId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `courseTopicPublic` field. */
  courseTopicPublic?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `nameSearch` field. */
  nameSearch?: Maybe<Scalars['String']>;
};

/** A filter to be used against `Item` object types. All fields are combined with a logical ‘and.’ */
export type ItemFilter = {
  /** Filter by the object’s `id` field. */
  id?: Maybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: Maybe<ItemTypeFilter>;
  /** Filter by the object’s `courseId` field. */
  courseId?: Maybe<IntFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `nameSearch` field. */
  nameSearch?: Maybe<StringFilter>;
  /** Filter by the object’s `itemsByCourseId` relation. */
  itemsByCourseId?: Maybe<ItemToManyItemFilter>;
  /** Some related `itemsByCourseId` exist. */
  itemsByCourseIdExist?: Maybe<Scalars['Boolean']>;
  /** Filter by the object’s `itemSharesByPath` relation. */
  itemSharesByPath?: Maybe<ItemToManyItemShareFilter>;
  /** Some related `itemSharesByPath` exist. */
  itemSharesByPathExist?: Maybe<Scalars['Boolean']>;
  /** Filter by the object’s `studentsByCourseId` relation. */
  studentsByCourseId?: Maybe<ItemToManyStudentFilter>;
  /** Some related `studentsByCourseId` exist. */
  studentsByCourseIdExist?: Maybe<Scalars['Boolean']>;
  /** Filter by the object’s `sessionsByTopicId` relation. */
  sessionsByTopicId?: Maybe<ItemToManySessionFilter>;
  /** Some related `sessionsByTopicId` exist. */
  sessionsByTopicIdExist?: Maybe<Scalars['Boolean']>;
  /** Filter by the object’s `forumTopicsByCourseId` relation. */
  forumTopicsByCourseId?: Maybe<ItemToManyForumTopicFilter>;
  /** Some related `forumTopicsByCourseId` exist. */
  forumTopicsByCourseIdExist?: Maybe<Scalars['Boolean']>;
  /** Filter by the object’s `course` relation. */
  course?: Maybe<ItemFilter>;
  /** A related `course` exists. */
  courseExists?: Maybe<Scalars['Boolean']>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<ItemFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<ItemFilter>>;
  /** Negates the expression. */
  not?: Maybe<ItemFilter>;
};

/** Represents an update to a `Item`. Fields that are set will be updated. */
export type ItemPatch = {
  courseTopicPublic?: Maybe<Scalars['Boolean']>;
  courseSignupCode?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  name?: Maybe<Scalars['String']>;
};

export type ItemShare = {
  __typename?: 'ItemShare';
  path: Scalars['String'];
  personId: Scalars['Int'];
  role: ItemShareRole;
  /** Reads a single `Item` that is related to this `ItemShare`. */
  itemByPath?: Maybe<Item>;
  /** Reads a single `Person` that is related to this `ItemShare`. */
  person?: Maybe<Person>;
  personPublicProfile?: Maybe<PersonPublicProfile>;
};

/** A filter to be used against `ItemShare` object types. All fields are combined with a logical ‘and.’ */
export type ItemShareFilter = {
  /** Filter by the object’s `personId` field. */
  personId?: Maybe<IntFilter>;
  /** Filter by the object’s `itemByPath` relation. */
  itemByPath?: Maybe<ItemFilter>;
  /** Filter by the object’s `person` relation. */
  person?: Maybe<PersonFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<ItemShareFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<ItemShareFilter>>;
  /** Negates the expression. */
  not?: Maybe<ItemShareFilter>;
};

export type ItemShareFolder = Node & {
  __typename?: 'ItemShareFolder';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

/** A connection to a list of `ItemShareFolder` values. */
export type ItemShareFoldersConnection = {
  __typename?: 'ItemShareFoldersConnection';
  /** A list of `ItemShareFolder` objects. */
  nodes: Array<Maybe<ItemShareFolder>>;
  /** A list of edges which contains the `ItemShareFolder` and cursor to aid in pagination. */
  edges: Array<ItemShareFoldersEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ItemShareFolder` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ItemShareFolder` edge in the connection. */
export type ItemShareFoldersEdge = {
  __typename?: 'ItemShareFoldersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ItemShareFolder` at the end of the edge. */
  node?: Maybe<ItemShareFolder>;
};

/** Represents an update to a `ItemShare`. Fields that are set will be updated. */
export type ItemSharePatch = {
  role?: Maybe<ItemShareRole>;
};

export enum ItemShareRole {
  Presenter = 'PRESENTER',
  Editor = 'EDITOR',
  Admin = 'ADMIN'
}

/** A connection to a list of `ItemShare` values. */
export type ItemSharesConnection = {
  __typename?: 'ItemSharesConnection';
  /** A list of `ItemShare` objects. */
  nodes: Array<Maybe<ItemShare>>;
  /** A list of edges which contains the `ItemShare` and cursor to aid in pagination. */
  edges: Array<ItemSharesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ItemShare` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ItemShare` edge in the connection. */
export type ItemSharesEdge = {
  __typename?: 'ItemSharesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ItemShare` at the end of the edge. */
  node?: Maybe<ItemShare>;
};

/** A filter to be used against many `ForumTopic` object types. All fields are combined with a logical ‘and.’ */
export type ItemToManyForumTopicFilter = {
  /** Every related `ForumTopic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: Maybe<ForumTopicFilter>;
  /** Some related `ForumTopic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: Maybe<ForumTopicFilter>;
  /** No related `ForumTopic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: Maybe<ForumTopicFilter>;
};

/** A filter to be used against many `Item` object types. All fields are combined with a logical ‘and.’ */
export type ItemToManyItemFilter = {
  /** Every related `Item` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: Maybe<ItemFilter>;
  /** Some related `Item` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: Maybe<ItemFilter>;
  /** No related `Item` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: Maybe<ItemFilter>;
};

/** A filter to be used against many `ItemShare` object types. All fields are combined with a logical ‘and.’ */
export type ItemToManyItemShareFilter = {
  /** Every related `ItemShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: Maybe<ItemShareFilter>;
  /** Some related `ItemShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: Maybe<ItemShareFilter>;
  /** No related `ItemShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: Maybe<ItemShareFilter>;
};

/** A filter to be used against many `Session` object types. All fields are combined with a logical ‘and.’ */
export type ItemToManySessionFilter = {
  /** Every related `Session` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: Maybe<SessionFilter>;
  /** Some related `Session` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: Maybe<SessionFilter>;
  /** No related `Session` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: Maybe<SessionFilter>;
};

/** A filter to be used against many `Student` object types. All fields are combined with a logical ‘and.’ */
export type ItemToManyStudentFilter = {
  /** Every related `Student` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: Maybe<StudentFilter>;
  /** Some related `Student` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: Maybe<StudentFilter>;
  /** No related `Student` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: Maybe<StudentFilter>;
};

export enum ItemType {
  Folder = 'FOLDER',
  Course = 'COURSE',
  Topic = 'TOPIC'
}

/** A filter to be used against ItemType fields. All fields are combined with a logical ‘and.’ */
export type ItemTypeFilter = {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<ItemType>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<ItemType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<ItemType>;
};

export enum ItemTypeTopic {
  Keynote = 'KEYNOTE',
  Quiz = 'QUIZ'
}

/** A connection to a list of `Item` values. */
export type ItemsConnection = {
  __typename?: 'ItemsConnection';
  /** A list of `Item` objects. */
  nodes: Array<Maybe<Item>>;
  /** A list of edges which contains the `Item` and cursor to aid in pagination. */
  edges: Array<ItemsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Item` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Item` edge in the connection. */
export type ItemsEdge = {
  __typename?: 'ItemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Item` at the end of the edge. */
  node?: Maybe<Item>;
};

/** Methods to use when ordering `Item`. */
export enum ItemsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  PathAsc = 'PATH_ASC',
  PathDesc = 'PATH_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  CourseIdAsc = 'COURSE_ID_ASC',
  CourseIdDesc = 'COURSE_ID_DESC',
  CourseTopicPublicAsc = 'COURSE_TOPIC_PUBLIC_ASC',
  CourseTopicPublicDesc = 'COURSE_TOPIC_PUBLIC_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  NameSearchAsc = 'NAME_SEARCH_ASC',
  NameSearchDesc = 'NAME_SEARCH_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}



export type Messenger = Node & {
  __typename?: 'Messenger';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['Int'];
  courseId: Scalars['Int'];
  studentId: Scalars['Int'];
  presenterId: Scalars['Int'];
  studentUnread: Scalars['Int'];
  presenterUnread: Scalars['Int'];
  lastMessageSentAt: Scalars['Datetime'];
  messages: Scalars['JSON'];
  /** Reads a single `Item` that is related to this `Messenger`. */
  course?: Maybe<Item>;
  /** Reads a single `Person` that is related to this `Messenger`. */
  student?: Maybe<Person>;
  /** Reads a single `Student` that is related to this `Messenger`. */
  studentByStudentIdAndCourseId?: Maybe<Student>;
  /** Reads a single `Person` that is related to this `Messenger`. */
  presenter?: Maybe<Person>;
};

/** A connection to a list of `MessengerActivity` values. */
export type MessengerActivitiesConnection = {
  __typename?: 'MessengerActivitiesConnection';
  /** A list of `MessengerActivity` objects. */
  nodes: Array<Maybe<MessengerActivity>>;
  /** A list of edges which contains the `MessengerActivity` and cursor to aid in pagination. */
  edges: Array<MessengerActivitiesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MessengerActivity` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MessengerActivity` edge in the connection. */
export type MessengerActivitiesEdge = {
  __typename?: 'MessengerActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MessengerActivity` at the end of the edge. */
  node?: Maybe<MessengerActivity>;
};

export type MessengerActivity = Node & {
  __typename?: 'MessengerActivity';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['Int'];
  courseId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  presenterId?: Maybe<Scalars['Int']>;
  personId?: Maybe<Scalars['Int']>;
  unreadMessages?: Maybe<Scalars['Int']>;
  lastMessageSentAt?: Maybe<Scalars['Datetime']>;
  lastMessage?: Maybe<Scalars['JSON']>;
  courseName?: Maybe<Scalars['String']>;
  personPublicProfile?: Maybe<PersonPublicProfile>;
};

/** All input for the `messengerRead` mutation. */
export type MessengerReadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  courseId: Scalars['Int'];
  studentId: Scalars['Int'];
  presenterId: Scalars['Int'];
};

/** The output of our `messengerRead` mutation. */
export type MessengerReadPayload = {
  __typename?: 'MessengerReadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  messenger?: Maybe<Messenger>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `Messenger`. */
  course?: Maybe<Item>;
  /** Reads a single `Person` that is related to this `Messenger`. */
  student?: Maybe<Person>;
  /** Reads a single `Student` that is related to this `Messenger`. */
  studentByStudentIdAndCourseId?: Maybe<Student>;
  /** Reads a single `Person` that is related to this `Messenger`. */
  presenter?: Maybe<Person>;
};

/** All input for the `messengerSend` mutation. */
export type MessengerSendInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  courseId: Scalars['Int'];
  studentId: Scalars['Int'];
  presenterId: Scalars['Int'];
  message: Scalars['String'];
};

/** The output of our `messengerSend` mutation. */
export type MessengerSendPayload = {
  __typename?: 'MessengerSendPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Creates a single `Contact`. */
  createContact?: Maybe<CreateContactPayload>;
  /** Creates a single `ContactGroup`. */
  createContactGroup?: Maybe<CreateContactGroupPayload>;
  /** Creates a single `ForumPersonActivity`. */
  createForumPersonActivity?: Maybe<CreateForumPersonActivityPayload>;
  /** Creates a single `ForumTopic`. */
  createForumTopic?: Maybe<CreateForumTopicPayload>;
  /** Creates a single `Session`. */
  createSession?: Maybe<CreateSessionPayload>;
  /** Creates a single `StudentGroup`. */
  createStudentGroup?: Maybe<CreateStudentGroupPayload>;
  /** Updates a single `Contact` using its globally unique id and a patch. */
  updateContactByNodeId?: Maybe<UpdateContactPayload>;
  /** Updates a single `Contact` using a unique key and a patch. */
  updateContact?: Maybe<UpdateContactPayload>;
  /** Updates a single `Contact` using a unique key and a patch. */
  updateContactByPersonIdAndContactPersonId?: Maybe<UpdateContactPayload>;
  /** Updates a single `Contact` using a unique key and a patch. */
  updateContactByPersonIdAndContactEmailHash?: Maybe<UpdateContactPayload>;
  /** Updates a single `ContactGroup` using its globally unique id and a patch. */
  updateContactGroupByNodeId?: Maybe<UpdateContactGroupPayload>;
  /** Updates a single `ContactGroup` using a unique key and a patch. */
  updateContactGroup?: Maybe<UpdateContactGroupPayload>;
  /** Updates a single `ContactGroup` using a unique key and a patch. */
  updateContactGroupByPersonIdAndName?: Maybe<UpdateContactGroupPayload>;
  /** Updates a single `ForumTopic` using its globally unique id and a patch. */
  updateForumTopicByNodeId?: Maybe<UpdateForumTopicPayload>;
  /** Updates a single `ForumTopic` using a unique key and a patch. */
  updateForumTopic?: Maybe<UpdateForumTopicPayload>;
  /** Updates a single `ForumTopic` using a unique key and a patch. */
  updateForumTopicByIdAndCourseId?: Maybe<UpdateForumTopicPayload>;
  /** Updates a single `Item` using its globally unique id and a patch. */
  updateItemByNodeId?: Maybe<UpdateItemPayload>;
  /** Updates a single `Item` using a unique key and a patch. */
  updateItem?: Maybe<UpdateItemPayload>;
  /** Updates a single `ItemShare` using a unique key and a patch. */
  updateItemShareByPathAndPersonId?: Maybe<UpdateItemSharePayload>;
  /** Updates a single `Person` using its globally unique id and a patch. */
  updatePersonByNodeId?: Maybe<UpdatePersonPayload>;
  /** Updates a single `Person` using a unique key and a patch. */
  updatePerson?: Maybe<UpdatePersonPayload>;
  /** Updates a single `Session` using its globally unique id and a patch. */
  updateSessionByNodeId?: Maybe<UpdateSessionPayload>;
  /** Updates a single `Session` using a unique key and a patch. */
  updateSession?: Maybe<UpdateSessionPayload>;
  /** Updates a single `Student` using its globally unique id and a patch. */
  updateStudentByNodeId?: Maybe<UpdateStudentPayload>;
  /** Updates a single `Student` using a unique key and a patch. */
  updateStudent?: Maybe<UpdateStudentPayload>;
  /** Updates a single `StudentGroup` using its globally unique id and a patch. */
  updateStudentGroupByNodeId?: Maybe<UpdateStudentGroupPayload>;
  /** Updates a single `StudentGroup` using a unique key and a patch. */
  updateStudentGroup?: Maybe<UpdateStudentGroupPayload>;
  /** Updates a single `StudentGroup` using a unique key and a patch. */
  updateStudentGroupByCourseIdAndId?: Maybe<UpdateStudentGroupPayload>;
  /** Deletes a single `Contact` using its globally unique id. */
  deleteContactByNodeId?: Maybe<DeleteContactPayload>;
  /** Deletes a single `Contact` using a unique key. */
  deleteContact?: Maybe<DeleteContactPayload>;
  /** Deletes a single `Contact` using a unique key. */
  deleteContactByPersonIdAndContactPersonId?: Maybe<DeleteContactPayload>;
  /** Deletes a single `Contact` using a unique key. */
  deleteContactByPersonIdAndContactEmailHash?: Maybe<DeleteContactPayload>;
  /** Deletes a single `ContactGroup` using its globally unique id. */
  deleteContactGroupByNodeId?: Maybe<DeleteContactGroupPayload>;
  /** Deletes a single `ContactGroup` using a unique key. */
  deleteContactGroup?: Maybe<DeleteContactGroupPayload>;
  /** Deletes a single `ContactGroup` using a unique key. */
  deleteContactGroupByPersonIdAndName?: Maybe<DeleteContactGroupPayload>;
  /** Deletes a single `ForumTopic` using its globally unique id. */
  deleteForumTopicByNodeId?: Maybe<DeleteForumTopicPayload>;
  /** Deletes a single `ForumTopic` using a unique key. */
  deleteForumTopic?: Maybe<DeleteForumTopicPayload>;
  /** Deletes a single `ForumTopic` using a unique key. */
  deleteForumTopicByIdAndCourseId?: Maybe<DeleteForumTopicPayload>;
  /** Deletes a single `ForumTopicStudentGroup` using its globally unique id. */
  deleteForumTopicStudentGroupByNodeId?: Maybe<DeleteForumTopicStudentGroupPayload>;
  /** Deletes a single `ForumTopicStudentGroup` using a unique key. */
  deleteForumTopicStudentGroup?: Maybe<DeleteForumTopicStudentGroupPayload>;
  /** Deletes a single `ItemShare` using a unique key. */
  deleteItemShareByPathAndPersonId?: Maybe<DeleteItemSharePayload>;
  /** Deletes a single `PersonOauthAccount` using a unique key. */
  deletePersonOauthAccountByOauthProviderAndOauthId?: Maybe<DeletePersonOauthAccountPayload>;
  /** Deletes a single `Student` using its globally unique id. */
  deleteStudentByNodeId?: Maybe<DeleteStudentPayload>;
  /** Deletes a single `Student` using a unique key. */
  deleteStudent?: Maybe<DeleteStudentPayload>;
  attendeeAttachmentDelete?: Maybe<AttendeeAttachmentDeletePayload>;
  attendeeAttachmentUploadComplete?: Maybe<AttendeeAttachmentUploadCompletePayload>;
  attendeeAttachmentUploadStart?: Maybe<AttendeeAttachmentUploadStartPayload>;
  attendeeGuestSignupCodeJoin?: Maybe<AttendeeGuestSignupCodeJoinPayload>;
  attendeeResponseCreate?: Maybe<AttendeeResponseCreatePayload>;
  attendeeSignupCodeJoinCourse?: Maybe<AttendeeSignupCodeJoinCoursePayload>;
  attendeeSignupCodeJoinGroup?: Maybe<AttendeeSignupCodeJoinGroupPayload>;
  attendeeSignupCodeJoinSession?: Maybe<AttendeeSignupCodeJoinSessionPayload>;
  createAttendeeFileDeleteJwt?: Maybe<CreateAttendeeFileDeleteJwtPayload>;
  createAttendeeFileUploadJwt?: Maybe<CreateAttendeeFileUploadJwtPayload>;
  createForumTopicStudentGroup?: Maybe<CreateForumTopicStudentGroupPayload>;
  createItem?: Maybe<CreateItemPayload>;
  createItemDuplicate?: Maybe<CreateItemDuplicatePayload>;
  createItemFileDeleteJwt?: Maybe<CreateItemFileDeleteJwtPayload>;
  createItemFileUploadJwt?: Maybe<CreateItemFileUploadJwtPayload>;
  createItemShare?: Maybe<CreateItemSharePayload>;
  createPersonFileDeleteJwt?: Maybe<CreatePersonFileDeleteJwtPayload>;
  createPersonFileUploadJwt?: Maybe<CreatePersonFileUploadJwtPayload>;
  createSessionProjectorAuthCode?: Maybe<CreateSessionProjectorAuthCodePayload>;
  createStudent?: Maybe<CreateStudentPayload>;
  deleteItem?: Maybe<DeleteItemPayload>;
  deleteSession?: Maybe<DeleteSessionPayload>;
  deleteStudentGroup?: Maybe<DeleteStudentGroupPayload>;
  forumTopicPostEdit?: Maybe<ForumTopicPostEditPayload>;
  forumTopicPostSend?: Maybe<ForumTopicPostSendPayload>;
  forumTopicPostSetHide?: Maybe<ForumTopicPostSetHidePayload>;
  forumTopicTrashEmpty?: Maybe<ForumTopicTrashEmptyPayload>;
  itemAttachmentDelete?: Maybe<ItemAttachmentDeletePayload>;
  itemAttachmentUploadComplete?: Maybe<ItemAttachmentUploadCompletePayload>;
  itemAttachmentUploadStart?: Maybe<ItemAttachmentUploadStartPayload>;
  itemAttachmentsPaste?: Maybe<ItemAttachmentsPastePayload>;
  messengerRead?: Maybe<MessengerReadPayload>;
  messengerSend?: Maybe<MessengerSendPayload>;
  personAuthenticate?: Maybe<PersonAuthenticatePayload>;
  personAuthenticateTokenRefresh?: Maybe<PersonAuthenticateTokenRefreshPayload>;
  personAvatarDelete?: Maybe<PersonAvatarDeletePayload>;
  personAvatarUploadComplete?: Maybe<PersonAvatarUploadCompletePayload>;
  personAvatarUploadStart?: Maybe<PersonAvatarUploadStartPayload>;
  sessionAttendeeChatMessageSend?: Maybe<SessionAttendeeChatMessageSendPayload>;
  sessionChatMessageSend?: Maybe<SessionChatMessageSendPayload>;
  sessionProjectorAuthenticate?: Maybe<SessionProjectorAuthenticatePayload>;
  studentSetContactName?: Maybe<StudentSetContactNamePayload>;
  trashEmpty?: Maybe<TrashEmptyPayload>;
  updateAttendeeResponse?: Maybe<UpdateAttendeeResponsePayload>;
  updateAttendeeResponseAndSessionStats?: Maybe<UpdateAttendeeResponseAndSessionStatsPayload>;
  updateAttendeeResponseFinish?: Maybe<UpdateAttendeeResponseFinishPayload>;
  updateAttendeeResponseMeta?: Maybe<UpdateAttendeeResponseMetaPayload>;
  updateAttendeeResponseNext?: Maybe<UpdateAttendeeResponseNextPayload>;
  updateAttendeeResponseSlideMeta?: Maybe<UpdateAttendeeResponseSlideMetaPayload>;
  updateAttendeeResponseStart?: Maybe<UpdateAttendeeResponseStartPayload>;
  updateForumPersonActivity?: Maybe<UpdateForumPersonActivityPayload>;
  updateItemCourseTopicMove?: Maybe<UpdateItemCourseTopicMovePayload>;
  updateItemData?: Maybe<UpdateItemDataPayload>;
  updateItemMove?: Maybe<UpdateItemMovePayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContactGroupArgs = {
  input: CreateContactGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateForumPersonActivityArgs = {
  input: CreateForumPersonActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateForumTopicArgs = {
  input: CreateForumTopicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSessionArgs = {
  input: CreateSessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateStudentGroupArgs = {
  input: CreateStudentGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContactByNodeIdArgs = {
  input: UpdateContactByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContactByPersonIdAndContactPersonIdArgs = {
  input: UpdateContactByPersonIdAndContactPersonIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContactByPersonIdAndContactEmailHashArgs = {
  input: UpdateContactByPersonIdAndContactEmailHashInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContactGroupByNodeIdArgs = {
  input: UpdateContactGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContactGroupArgs = {
  input: UpdateContactGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContactGroupByPersonIdAndNameArgs = {
  input: UpdateContactGroupByPersonIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateForumTopicByNodeIdArgs = {
  input: UpdateForumTopicByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateForumTopicArgs = {
  input: UpdateForumTopicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateForumTopicByIdAndCourseIdArgs = {
  input: UpdateForumTopicByIdAndCourseIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateItemByNodeIdArgs = {
  input: UpdateItemByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateItemArgs = {
  input: UpdateItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateItemShareByPathAndPersonIdArgs = {
  input: UpdateItemShareByPathAndPersonIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePersonByNodeIdArgs = {
  input: UpdatePersonByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePersonArgs = {
  input: UpdatePersonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSessionByNodeIdArgs = {
  input: UpdateSessionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSessionArgs = {
  input: UpdateSessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateStudentByNodeIdArgs = {
  input: UpdateStudentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateStudentArgs = {
  input: UpdateStudentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateStudentGroupByNodeIdArgs = {
  input: UpdateStudentGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateStudentGroupArgs = {
  input: UpdateStudentGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateStudentGroupByCourseIdAndIdArgs = {
  input: UpdateStudentGroupByCourseIdAndIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContactByNodeIdArgs = {
  input: DeleteContactByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContactArgs = {
  input: DeleteContactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContactByPersonIdAndContactPersonIdArgs = {
  input: DeleteContactByPersonIdAndContactPersonIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContactByPersonIdAndContactEmailHashArgs = {
  input: DeleteContactByPersonIdAndContactEmailHashInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContactGroupByNodeIdArgs = {
  input: DeleteContactGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContactGroupArgs = {
  input: DeleteContactGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContactGroupByPersonIdAndNameArgs = {
  input: DeleteContactGroupByPersonIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteForumTopicByNodeIdArgs = {
  input: DeleteForumTopicByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteForumTopicArgs = {
  input: DeleteForumTopicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteForumTopicByIdAndCourseIdArgs = {
  input: DeleteForumTopicByIdAndCourseIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteForumTopicStudentGroupByNodeIdArgs = {
  input: DeleteForumTopicStudentGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteForumTopicStudentGroupArgs = {
  input: DeleteForumTopicStudentGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteItemShareByPathAndPersonIdArgs = {
  input: DeleteItemShareByPathAndPersonIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePersonOauthAccountByOauthProviderAndOauthIdArgs = {
  input: DeletePersonOauthAccountByOauthProviderAndOauthIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteStudentByNodeIdArgs = {
  input: DeleteStudentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteStudentArgs = {
  input: DeleteStudentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAttendeeAttachmentDeleteArgs = {
  input: AttendeeAttachmentDeleteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAttendeeAttachmentUploadCompleteArgs = {
  input: AttendeeAttachmentUploadCompleteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAttendeeAttachmentUploadStartArgs = {
  input: AttendeeAttachmentUploadStartInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAttendeeGuestSignupCodeJoinArgs = {
  input: AttendeeGuestSignupCodeJoinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAttendeeResponseCreateArgs = {
  input: AttendeeResponseCreateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAttendeeSignupCodeJoinCourseArgs = {
  input: AttendeeSignupCodeJoinCourseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAttendeeSignupCodeJoinGroupArgs = {
  input: AttendeeSignupCodeJoinGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAttendeeSignupCodeJoinSessionArgs = {
  input: AttendeeSignupCodeJoinSessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAttendeeFileDeleteJwtArgs = {
  input: CreateAttendeeFileDeleteJwtInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAttendeeFileUploadJwtArgs = {
  input: CreateAttendeeFileUploadJwtInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateForumTopicStudentGroupArgs = {
  input: CreateForumTopicStudentGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateItemArgs = {
  input: CreateItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateItemDuplicateArgs = {
  input: CreateItemDuplicateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateItemFileDeleteJwtArgs = {
  input: CreateItemFileDeleteJwtInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateItemFileUploadJwtArgs = {
  input: CreateItemFileUploadJwtInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateItemShareArgs = {
  input: CreateItemShareInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePersonFileDeleteJwtArgs = {
  input: CreatePersonFileDeleteJwtInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePersonFileUploadJwtArgs = {
  input: CreatePersonFileUploadJwtInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSessionProjectorAuthCodeArgs = {
  input: CreateSessionProjectorAuthCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateStudentArgs = {
  input: CreateStudentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteItemArgs = {
  input: DeleteItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSessionArgs = {
  input: DeleteSessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteStudentGroupArgs = {
  input: DeleteStudentGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationForumTopicPostEditArgs = {
  input: ForumTopicPostEditInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationForumTopicPostSendArgs = {
  input: ForumTopicPostSendInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationForumTopicPostSetHideArgs = {
  input: ForumTopicPostSetHideInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationForumTopicTrashEmptyArgs = {
  input: ForumTopicTrashEmptyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationItemAttachmentDeleteArgs = {
  input: ItemAttachmentDeleteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationItemAttachmentUploadCompleteArgs = {
  input: ItemAttachmentUploadCompleteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationItemAttachmentUploadStartArgs = {
  input: ItemAttachmentUploadStartInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationItemAttachmentsPasteArgs = {
  input: ItemAttachmentsPasteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMessengerReadArgs = {
  input: MessengerReadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMessengerSendArgs = {
  input: MessengerSendInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPersonAuthenticateArgs = {
  input: PersonAuthenticateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPersonAuthenticateTokenRefreshArgs = {
  input: PersonAuthenticateTokenRefreshInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPersonAvatarDeleteArgs = {
  input: PersonAvatarDeleteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPersonAvatarUploadCompleteArgs = {
  input: PersonAvatarUploadCompleteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPersonAvatarUploadStartArgs = {
  input: PersonAvatarUploadStartInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSessionAttendeeChatMessageSendArgs = {
  input: SessionAttendeeChatMessageSendInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSessionChatMessageSendArgs = {
  input: SessionChatMessageSendInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSessionProjectorAuthenticateArgs = {
  input: SessionProjectorAuthenticateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationStudentSetContactNameArgs = {
  input: StudentSetContactNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationTrashEmptyArgs = {
  input: TrashEmptyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAttendeeResponseArgs = {
  input: UpdateAttendeeResponseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAttendeeResponseAndSessionStatsArgs = {
  input: UpdateAttendeeResponseAndSessionStatsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAttendeeResponseFinishArgs = {
  input: UpdateAttendeeResponseFinishInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAttendeeResponseMetaArgs = {
  input: UpdateAttendeeResponseMetaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAttendeeResponseNextArgs = {
  input: UpdateAttendeeResponseNextInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAttendeeResponseSlideMetaArgs = {
  input: UpdateAttendeeResponseSlideMetaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAttendeeResponseStartArgs = {
  input: UpdateAttendeeResponseStartInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateForumPersonActivityArgs = {
  input: UpdateForumPersonActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateItemCourseTopicMoveArgs = {
  input: UpdateItemCourseTopicMoveInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateItemDataArgs = {
  input: UpdateItemDataInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateItemMoveArgs = {
  input: UpdateItemMoveInput;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
};

/** A `Person` edge in the connection. */
export type PeopleEdge = {
  __typename?: 'PeopleEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Person` at the end of the edge. */
  node?: Maybe<Person>;
};

export type Person = Node & {
  __typename?: 'Person';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['Int'];
  name: Scalars['String'];
  nameSearch: Scalars['String'];
  avatarUrl?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone?: Maybe<Scalars['Int']>;
  passwordLogin: Scalars['Boolean'];
  quota: Scalars['Int'];
  locale: Scalars['String'];
  timezone: Scalars['String'];
  profileMenu?: Maybe<PersonMenu>;
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `ItemShare`. */
  itemShares: ItemSharesConnection;
  /** Reads and enables pagination through a set of `Contact`. */
  contacts: ContactsConnection;
  /** Reads and enables pagination through a set of `ContactGroup`. */
  contactGroups: ContactGroupsConnection;
  /** Reads a single `ForumPersonActivity` that is related to this `Person`. */
  forumPersonActivityByPersonId?: Maybe<ForumPersonActivity>;
  /**
   * Reads and enables pagination through a set of `ForumPersonActivity`.
   * @deprecated Please use forumPersonActivityByPersonId instead
   */
  forumPersonActivities: ForumPersonActivitiesConnection;
  /** Reads and enables pagination through a set of `PersonOauthAccount`. */
  personOauthAccounts: PersonOauthAccountsConnection;
};


export type PersonItemSharesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


export type PersonContactsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ContactsOrderBy>>;
  condition?: Maybe<ContactCondition>;
  filter?: Maybe<ContactFilter>;
};


export type PersonContactGroupsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ContactGroupsOrderBy>>;
  condition?: Maybe<ContactGroupCondition>;
  filter?: Maybe<ContactGroupFilter>;
};


export type PersonForumPersonActivitiesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ForumPersonActivitiesOrderBy>>;
  condition?: Maybe<ForumPersonActivityCondition>;
  filter?: Maybe<ForumPersonActivityFilter>;
};


export type PersonPersonOauthAccountsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<PersonOauthAccountsOrderBy>>;
  condition?: Maybe<PersonOauthAccountCondition>;
  filter?: Maybe<PersonOauthAccountFilter>;
};

/** All input for the `personAuthenticate` mutation. */
export type PersonAuthenticateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};

/** The output of our `personAuthenticate` mutation. */
export type PersonAuthenticatePayload = {
  __typename?: 'PersonAuthenticatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `personAuthenticateTokenRefresh` mutation. */
export type PersonAuthenticateTokenRefreshInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** The output of our `personAuthenticateTokenRefresh` mutation. */
export type PersonAuthenticateTokenRefreshPayload = {
  __typename?: 'PersonAuthenticateTokenRefreshPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `personAvatarDelete` mutation. */
export type PersonAvatarDeleteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** The output of our `personAvatarDelete` mutation. */
export type PersonAvatarDeletePayload = {
  __typename?: 'PersonAvatarDeletePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  person?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `Person`. May be used by Relay 1. */
  personEdge?: Maybe<PeopleEdge>;
};

/** All input for the `personAvatarUploadComplete` mutation. */
export type PersonAvatarUploadCompleteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  src: Scalars['String'];
};

/** The output of our `personAvatarUploadComplete` mutation. */
export type PersonAvatarUploadCompletePayload = {
  __typename?: 'PersonAvatarUploadCompletePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  person?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `Person`. May be used by Relay 1. */
  personEdge?: Maybe<PeopleEdge>;
};

/** All input for the `personAvatarUploadStart` mutation. */
export type PersonAvatarUploadStartInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  type: Scalars['String'];
  name: Scalars['String'];
};

/** The output of our `personAvatarUploadStart` mutation. */
export type PersonAvatarUploadStartPayload = {
  __typename?: 'PersonAvatarUploadStartPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A filter to be used against `Person` object types. All fields are combined with a logical ‘and.’ */
export type PersonFilter = {
  /** Filter by the object’s `id` field. */
  id?: Maybe<IntFilter>;
  /** Filter by the object’s `nameSearch` field. */
  nameSearch?: Maybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: Maybe<StringFilter>;
  /** Filter by the object’s `itemShares` relation. */
  itemShares?: Maybe<PersonToManyItemShareFilter>;
  /** Some related `itemShares` exist. */
  itemSharesExist?: Maybe<Scalars['Boolean']>;
  /** Filter by the object’s `contacts` relation. */
  contacts?: Maybe<PersonToManyContactFilter>;
  /** Some related `contacts` exist. */
  contactsExist?: Maybe<Scalars['Boolean']>;
  /** Filter by the object’s `contactGroups` relation. */
  contactGroups?: Maybe<PersonToManyContactGroupFilter>;
  /** Some related `contactGroups` exist. */
  contactGroupsExist?: Maybe<Scalars['Boolean']>;
  /** Filter by the object’s `forumPersonActivityByPersonId` relation. */
  forumPersonActivityByPersonId?: Maybe<ForumPersonActivityFilter>;
  /** A related `forumPersonActivityByPersonId` exists. */
  forumPersonActivityByPersonIdExists?: Maybe<Scalars['Boolean']>;
  /** Filter by the object’s `personOauthAccounts` relation. */
  personOauthAccounts?: Maybe<PersonToManyPersonOauthAccountFilter>;
  /** Some related `personOauthAccounts` exist. */
  personOauthAccountsExist?: Maybe<Scalars['Boolean']>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<PersonFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<PersonFilter>>;
  /** Negates the expression. */
  not?: Maybe<PersonFilter>;
};

export enum PersonMenu {
  Attendee = 'ATTENDEE',
  Presenter = 'PRESENTER'
}

export type PersonOauthAccount = {
  __typename?: 'PersonOauthAccount';
  personId: Scalars['Int'];
  oauthProvider: PersonOauthProvider;
  oauthId: Scalars['String'];
  oauthEmail: Scalars['String'];
  oauthName: Scalars['String'];
  oauthPicture?: Maybe<Scalars['String']>;
  oauthLocale?: Maybe<Scalars['String']>;
  /** Reads a single `Person` that is related to this `PersonOauthAccount`. */
  person?: Maybe<Person>;
};

/**
 * A condition to be used against `PersonOauthAccount` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PersonOauthAccountCondition = {
  /** Checks for equality with the object’s `personId` field. */
  personId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `oauthProvider` field. */
  oauthProvider?: Maybe<PersonOauthProvider>;
};

/** A filter to be used against `PersonOauthAccount` object types. All fields are combined with a logical ‘and.’ */
export type PersonOauthAccountFilter = {
  /** Filter by the object’s `personId` field. */
  personId?: Maybe<IntFilter>;
  /** Filter by the object’s `person` relation. */
  person?: Maybe<PersonFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<PersonOauthAccountFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<PersonOauthAccountFilter>>;
  /** Negates the expression. */
  not?: Maybe<PersonOauthAccountFilter>;
};

/** A connection to a list of `PersonOauthAccount` values. */
export type PersonOauthAccountsConnection = {
  __typename?: 'PersonOauthAccountsConnection';
  /** A list of `PersonOauthAccount` objects. */
  nodes: Array<Maybe<PersonOauthAccount>>;
  /** A list of edges which contains the `PersonOauthAccount` and cursor to aid in pagination. */
  edges: Array<PersonOauthAccountsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PersonOauthAccount` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PersonOauthAccount` edge in the connection. */
export type PersonOauthAccountsEdge = {
  __typename?: 'PersonOauthAccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PersonOauthAccount` at the end of the edge. */
  node?: Maybe<PersonOauthAccount>;
};

/** Methods to use when ordering `PersonOauthAccount`. */
export enum PersonOauthAccountsOrderBy {
  Natural = 'NATURAL',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  OauthProviderAsc = 'OAUTH_PROVIDER_ASC',
  OauthProviderDesc = 'OAUTH_PROVIDER_DESC'
}

export enum PersonOauthProvider {
  Google = 'GOOGLE',
  Azure = 'AZURE'
}

/** Represents an update to a `Person`. Fields that are set will be updated. */
export type PersonPatch = {
  name?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['Int']>;
  passwordLogin?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  profileMenu?: Maybe<PersonMenu>;
};

export type PersonPublicProfile = {
  __typename?: 'PersonPublicProfile';
  personId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

/** A connection to a list of `PersonPublicProfile` values. */
export type PersonPublicProfilesConnection = {
  __typename?: 'PersonPublicProfilesConnection';
  /** A list of `PersonPublicProfile` objects. */
  nodes: Array<Maybe<PersonPublicProfile>>;
  /** A list of edges which contains the `PersonPublicProfile` and cursor to aid in pagination. */
  edges: Array<PersonPublicProfilesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PersonPublicProfile` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PersonPublicProfile` edge in the connection. */
export type PersonPublicProfilesEdge = {
  __typename?: 'PersonPublicProfilesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PersonPublicProfile` at the end of the edge. */
  node?: Maybe<PersonPublicProfile>;
};

/** A filter to be used against many `Contact` object types. All fields are combined with a logical ‘and.’ */
export type PersonToManyContactFilter = {
  /** Every related `Contact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: Maybe<ContactFilter>;
  /** Some related `Contact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: Maybe<ContactFilter>;
  /** No related `Contact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: Maybe<ContactFilter>;
};

/** A filter to be used against many `ContactGroup` object types. All fields are combined with a logical ‘and.’ */
export type PersonToManyContactGroupFilter = {
  /** Every related `ContactGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: Maybe<ContactGroupFilter>;
  /** Some related `ContactGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: Maybe<ContactGroupFilter>;
  /** No related `ContactGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: Maybe<ContactGroupFilter>;
};

/** A filter to be used against many `ItemShare` object types. All fields are combined with a logical ‘and.’ */
export type PersonToManyItemShareFilter = {
  /** Every related `ItemShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: Maybe<ItemShareFilter>;
  /** Some related `ItemShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: Maybe<ItemShareFilter>;
  /** No related `ItemShare` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: Maybe<ItemShareFilter>;
};

/** A filter to be used against many `PersonOauthAccount` object types. All fields are combined with a logical ‘and.’ */
export type PersonToManyPersonOauthAccountFilter = {
  /** Every related `PersonOauthAccount` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: Maybe<PersonOauthAccountFilter>;
  /** Some related `PersonOauthAccount` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: Maybe<PersonOauthAccountFilter>;
  /** No related `PersonOauthAccount` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: Maybe<PersonOauthAccountFilter>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** Reads and enables pagination through a set of `AttendeeItem`. */
  attendeeItems?: Maybe<AttendeeItemsConnection>;
  /** Reads and enables pagination through a set of `ContactGroup`. */
  contactGroups?: Maybe<ContactGroupsConnection>;
  /** Reads and enables pagination through a set of `ForumTopic`. */
  forumTopics?: Maybe<ForumTopicsConnection>;
  /** Reads and enables pagination through a set of `Session`. */
  sessions?: Maybe<SessionsConnection>;
  /** Reads and enables pagination through a set of `SessionAttendee`. */
  sessionAttendees?: Maybe<SessionAttendeesConnection>;
  /** Reads and enables pagination through a set of `StudentGroup`. */
  studentGroups?: Maybe<StudentGroupsConnection>;
  attendeeForumTopic?: Maybe<AttendeeForumTopic>;
  attendeeItem?: Maybe<AttendeeItem>;
  contact?: Maybe<Contact>;
  contactByPersonIdAndContactPersonId?: Maybe<Contact>;
  contactByPersonIdAndContactEmailHash?: Maybe<Contact>;
  contactGroup?: Maybe<ContactGroup>;
  contactGroupByPersonIdAndName?: Maybe<ContactGroup>;
  forumPersonActivity?: Maybe<ForumPersonActivity>;
  forumTopic?: Maybe<ForumTopic>;
  forumTopicByIdAndCourseId?: Maybe<ForumTopic>;
  forumTopicStudentGroup?: Maybe<ForumTopicStudentGroup>;
  item?: Maybe<Item>;
  itemShareByPathAndPersonId?: Maybe<ItemShare>;
  itemShareFolder?: Maybe<ItemShareFolder>;
  messengerActivity?: Maybe<MessengerActivity>;
  messengerActivityByCourseIdAndStudentIdAndPresenterId?: Maybe<MessengerActivity>;
  person?: Maybe<Person>;
  personOauthAccountByOauthProviderAndOauthId?: Maybe<PersonOauthAccount>;
  session?: Maybe<Session>;
  sessionAttendee?: Maybe<SessionAttendee>;
  student?: Maybe<Student>;
  studentGroup?: Maybe<StudentGroup>;
  studentGroupByCourseIdAndId?: Maybe<StudentGroup>;
  /** Reads and enables pagination through a set of `AttendeeComingSession`. */
  attendeeComingSessions?: Maybe<AttendeeComingSessionsConnection>;
  /** Reads and enables pagination through a set of `ForumTopic`. */
  attendeeForumTopics?: Maybe<ForumTopicsConnection>;
  /** Reads and enables pagination through a set of `ForumTopic`. */
  attendeeForumTopicsRecent?: Maybe<ForumTopicsConnection>;
  attendeeGuestSignupCodeFind?: Maybe<Session>;
  /** Reads and enables pagination through a set of `AttendeeItem`. */
  attendeeItemChildren?: Maybe<AttendeeItemsConnection>;
  /** Reads and enables pagination through a set of `AttendeeItem`. */
  attendeeItemRecent?: Maybe<AttendeeItemsConnection>;
  /** Reads and enables pagination through a set of `AttendeeItem`. */
  attendeeItemSearch?: Maybe<AttendeeItemsConnection>;
  attendeeResponse?: Maybe<SessionAttendee>;
  attendeeSignupCodeFind?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `Contact`. */
  contacts?: Maybe<ContactsConnection>;
  /** Reads and enables pagination through a set of `StudentGroup`. */
  forumCourseStudentGroups?: Maybe<StudentGroupsConnection>;
  /** Reads and enables pagination through a set of `ForumTopic`. */
  forumTopicsRecent?: Maybe<ForumTopicsConnection>;
  /** Reads and enables pagination through a set of `ItemAttachment`. */
  itemAttachments?: Maybe<ItemAttachmentsConnection>;
  /** Reads and enables pagination through a set of `Item`. */
  itemChildren?: Maybe<ItemsConnection>;
  /** Reads and enables pagination through a set of `Item`. */
  itemShareFolderItems?: Maybe<ItemsConnection>;
  /** Reads and enables pagination through a set of `ItemShareFolder`. */
  itemShareFolders?: Maybe<ItemShareFoldersConnection>;
  /** Reads and enables pagination through a set of `ItemShare`. */
  itemShareTeam?: Maybe<ItemSharesConnection>;
  jsonbCoalesce?: Maybe<Scalars['JSON']>;
  me?: Maybe<Person>;
  /** Reads and enables pagination through a set of `MessengerActivity`. */
  messengerActivities?: Maybe<MessengerActivitiesConnection>;
  messengerHistory?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `PersonPublicProfile`. */
  personSearch?: Maybe<PersonPublicProfilesConnection>;
  /** Reads and enables pagination through a set of `SearchResult`. */
  search?: Maybe<SearchResultsConnection>;
  serverTime?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `SessionAttendee`. */
  sessionAttendeesByTopicId?: Maybe<SessionAttendeesConnection>;
  /** Reads and enables pagination through a set of `Session`. */
  sessionsRecent?: Maybe<SessionsConnection>;
  /** Reads and enables pagination through a set of `Student`. */
  students?: Maybe<StudentsConnection>;
  /** Reads and enables pagination through a set of `SearchResult`. */
  trashSearch?: Maybe<SearchResultsConnection>;
  xor?: Maybe<Scalars['Boolean']>;
  /** Reads a single `AttendeeForumTopic` using its globally unique `ID`. */
  attendeeForumTopicByNodeId?: Maybe<AttendeeForumTopic>;
  /** Reads a single `AttendeeItem` using its globally unique `ID`. */
  attendeeItemByNodeId?: Maybe<AttendeeItem>;
  /** Reads a single `Contact` using its globally unique `ID`. */
  contactByNodeId?: Maybe<Contact>;
  /** Reads a single `ContactGroup` using its globally unique `ID`. */
  contactGroupByNodeId?: Maybe<ContactGroup>;
  /** Reads a single `ForumPersonActivity` using its globally unique `ID`. */
  forumPersonActivityByNodeId?: Maybe<ForumPersonActivity>;
  /** Reads a single `ForumTopic` using its globally unique `ID`. */
  forumTopicByNodeId?: Maybe<ForumTopic>;
  /** Reads a single `ForumTopicStudentGroup` using its globally unique `ID`. */
  forumTopicStudentGroupByNodeId?: Maybe<ForumTopicStudentGroup>;
  /** Reads a single `Item` using its globally unique `ID`. */
  itemByNodeId?: Maybe<Item>;
  /** Reads a single `ItemShareFolder` using its globally unique `ID`. */
  itemShareFolderByNodeId?: Maybe<ItemShareFolder>;
  /** Reads a single `MessengerActivity` using its globally unique `ID`. */
  messengerActivityByNodeId?: Maybe<MessengerActivity>;
  /** Reads a single `Person` using its globally unique `ID`. */
  personByNodeId?: Maybe<Person>;
  /** Reads a single `Session` using its globally unique `ID`. */
  sessionByNodeId?: Maybe<Session>;
  /** Reads a single `SessionAttendee` using its globally unique `ID`. */
  sessionAttendeeByNodeId?: Maybe<SessionAttendee>;
  /** Reads a single `Student` using its globally unique `ID`. */
  studentByNodeId?: Maybe<Student>;
  /** Reads a single `StudentGroup` using its globally unique `ID`. */
  studentGroupByNodeId?: Maybe<StudentGroup>;
  /** Reads a single `SubscriptionPayload` using its globally unique `ID`. */
  subscriptionPayloadByNodeId?: Maybe<SubscriptionPayload>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAttendeeItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<AttendeeItemsOrderBy>>;
  filter?: Maybe<AttendeeItemFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContactGroupsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ContactGroupsOrderBy>>;
  condition?: Maybe<ContactGroupCondition>;
  filter?: Maybe<ContactGroupFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryForumTopicsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ForumTopicsOrderBy>>;
  condition?: Maybe<ForumTopicCondition>;
  filter?: Maybe<ForumTopicFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySessionsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SessionsOrderBy>>;
  condition?: Maybe<SessionCondition>;
  filter?: Maybe<SessionFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySessionAttendeesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SessionAttendeesOrderBy>>;
  condition?: Maybe<SessionAttendeeCondition>;
  filter?: Maybe<SessionAttendeeFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryStudentGroupsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<StudentGroupCondition>;
  filter?: Maybe<StudentGroupFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAttendeeForumTopicArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAttendeeItemArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContactArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContactByPersonIdAndContactPersonIdArgs = {
  personId: Scalars['Int'];
  contactPersonId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContactByPersonIdAndContactEmailHashArgs = {
  personId: Scalars['Int'];
  contactEmailHash: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContactGroupArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContactGroupByPersonIdAndNameArgs = {
  personId: Scalars['Int'];
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryForumPersonActivityArgs = {
  personId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryForumTopicArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryForumTopicByIdAndCourseIdArgs = {
  id: Scalars['Int'];
  courseId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryForumTopicStudentGroupArgs = {
  forumTopicId: Scalars['Int'];
  studentGroupId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryItemArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryItemShareByPathAndPersonIdArgs = {
  path: Scalars['String'];
  personId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryItemShareFolderArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMessengerActivityArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMessengerActivityByCourseIdAndStudentIdAndPresenterIdArgs = {
  courseId: Scalars['Int'];
  studentId: Scalars['Int'];
  presenterId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPersonArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPersonOauthAccountByOauthProviderAndOauthIdArgs = {
  oauthProvider: PersonOauthProvider;
  oauthId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySessionArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySessionAttendeeArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStudentArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStudentGroupArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStudentGroupByCourseIdAndIdArgs = {
  courseId: Scalars['Int'];
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAttendeeComingSessionsArgs = {
  days: Scalars['Int'];
  timezone: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAttendeeForumTopicsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ForumTopicCondition>;
  filter?: Maybe<ForumTopicFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAttendeeForumTopicsRecentArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAttendeeGuestSignupCodeFindArgs = {
  signupCode: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAttendeeItemChildrenArgs = {
  id: Scalars['Int'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAttendeeItemRecentArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAttendeeItemSearchArgs = {
  text: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAttendeeResponseArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAttendeeSignupCodeFindArgs = {
  code: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContactsArgs = {
  name?: Maybe<Scalars['String']>;
  groups?: Maybe<Scalars['JSON']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryForumCourseStudentGroupsArgs = {
  courseId: Scalars['Int'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryForumTopicsRecentArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryItemAttachmentsArgs = {
  itemId: Scalars['Int'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryItemChildrenArgs = {
  id: Scalars['Int'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ItemCondition>;
  filter?: Maybe<ItemFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryItemShareFolderItemsArgs = {
  id: Scalars['Int'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryItemShareFoldersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryItemShareTeamArgs = {
  id: Scalars['Int'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryJsonbCoalesceArgs = {
  arg0?: Maybe<Scalars['JSON']>;
  arg1?: Maybe<Scalars['JSON']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMessengerActivitiesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMessengerHistoryArgs = {
  courseId: Scalars['Int'];
  studentId: Scalars['Int'];
  presenterId: Scalars['Int'];
  before: Scalars['Int'];
  last: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPersonSearchArgs = {
  search: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchArgs = {
  text: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySessionAttendeesByTopicIdArgs = {
  topicId: Scalars['Int'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySessionsRecentArgs = {
  timezone: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryStudentsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<StudentCondition>;
  filter?: Maybe<StudentFilter>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTrashSearchArgs = {
  text: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryXorArgs = {
  a: Scalars['Boolean'];
  b: Scalars['Boolean'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAttendeeForumTopicByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAttendeeItemByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContactByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContactGroupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryForumPersonActivityByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryForumTopicByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryForumTopicStudentGroupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryItemByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryItemShareFolderByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMessengerActivityByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPersonByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySessionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySessionAttendeeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStudentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStudentGroupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySubscriptionPayloadByNodeIdArgs = {
  nodeId: Scalars['ID'];
};

export type SearchResult = {
  __typename?: 'SearchResult';
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<SearchResultType>;
  typeTopic?: Maybe<ItemTypeTopic>;
  createdAt?: Maybe<Scalars['Datetime']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
};

export enum SearchResultType {
  Folder = 'FOLDER',
  Course = 'COURSE',
  Topic = 'TOPIC',
  Session = 'SESSION',
  Group = 'GROUP',
  Student = 'STUDENT',
  Attendee = 'ATTENDEE'
}

/** A connection to a list of `SearchResult` values. */
export type SearchResultsConnection = {
  __typename?: 'SearchResultsConnection';
  /** A list of `SearchResult` objects. */
  nodes: Array<Maybe<SearchResult>>;
  /** A list of edges which contains the `SearchResult` and cursor to aid in pagination. */
  edges: Array<SearchResultsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SearchResult` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SearchResult` edge in the connection. */
export type SearchResultsEdge = {
  __typename?: 'SearchResultsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SearchResult` at the end of the edge. */
  node?: Maybe<SearchResult>;
};

export type Session = Node & {
  __typename?: 'Session';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['Int'];
  presenterId: Scalars['Int'];
  topicId: Scalars['Int'];
  topicPublic: Scalars['Boolean'];
  studentPublic?: Maybe<Scalars['Boolean']>;
  studentGroupId?: Maybe<Scalars['Int']>;
  signupCode?: Maybe<Scalars['String']>;
  retakes?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  startedAt?: Maybe<Scalars['Datetime']>;
  stoppedAt?: Maybe<Scalars['Datetime']>;
  data: Scalars['JSON'];
  /** Reads a single `Item` that is related to this `Session`. */
  topic?: Maybe<Item>;
  /** Reads a single `StudentGroup` that is related to this `Session`. */
  studentGroup?: Maybe<StudentGroup>;
  /** Reads and enables pagination through a set of `SessionAttendee`. */
  sessionAttendees: SessionAttendeesConnection;
  chatMessages?: Maybe<Scalars['JSON']>;
  chatSenderPublicProfile?: Maybe<PersonPublicProfile>;
  presenterPublicProfile?: Maybe<PersonPublicProfile>;
  topicInfo?: Maybe<Scalars['JSON']>;
  topicName?: Maybe<Scalars['String']>;
};


export type SessionSessionAttendeesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SessionAttendeesOrderBy>>;
  condition?: Maybe<SessionAttendeeCondition>;
  filter?: Maybe<SessionAttendeeFilter>;
};


export type SessionChatMessagesArgs = {
  before: Scalars['Int'];
  count: Scalars['Int'];
};


export type SessionChatSenderPublicProfileArgs = {
  messageId: Scalars['Int'];
};

export type SessionAttendee = Node & {
  __typename?: 'SessionAttendee';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['UUID'];
  personId?: Maybe<Scalars['Int']>;
  sessionId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  changedAt: Scalars['Datetime'];
  startedAt?: Maybe<Scalars['Datetime']>;
  finishedAt?: Maybe<Scalars['Datetime']>;
  data: Scalars['JSON'];
  presenterData: Scalars['JSON'];
  guestName?: Maybe<Scalars['String']>;
  /** Reads a single `Session` that is related to this `SessionAttendee`. */
  session?: Maybe<Session>;
  contactName?: Maybe<Scalars['String']>;
  publicProfile?: Maybe<PersonPublicProfile>;
  responseSession?: Maybe<Session>;
  responseTopic?: Maybe<Item>;
};

/** All input for the `sessionAttendeeChatMessageSend` mutation. */
export type SessionAttendeeChatMessageSendInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  attendeeId: Scalars['UUID'];
  message: Scalars['String'];
};

/** The output of our `sessionAttendeeChatMessageSend` mutation. */
export type SessionAttendeeChatMessageSendPayload = {
  __typename?: 'SessionAttendeeChatMessageSendPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/**
 * A condition to be used against `SessionAttendee` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SessionAttendeeCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `sessionId` field. */
  sessionId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `changedAt` field. */
  changedAt?: Maybe<Scalars['Datetime']>;
};

/** A filter to be used against `SessionAttendee` object types. All fields are combined with a logical ‘and.’ */
export type SessionAttendeeFilter = {
  /** Filter by the object’s `personId` field. */
  personId?: Maybe<IntFilter>;
  /** Filter by the object’s `sessionId` field. */
  sessionId?: Maybe<IntFilter>;
  /** Filter by the object’s `changedAt` field. */
  changedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `session` relation. */
  session?: Maybe<SessionFilter>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<SessionAttendeeFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<SessionAttendeeFilter>>;
  /** Negates the expression. */
  not?: Maybe<SessionAttendeeFilter>;
};

/** A connection to a list of `SessionAttendee` values. */
export type SessionAttendeesConnection = {
  __typename?: 'SessionAttendeesConnection';
  /** A list of `SessionAttendee` objects. */
  nodes: Array<Maybe<SessionAttendee>>;
  /** A list of edges which contains the `SessionAttendee` and cursor to aid in pagination. */
  edges: Array<SessionAttendeesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SessionAttendee` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SessionAttendee` edge in the connection. */
export type SessionAttendeesEdge = {
  __typename?: 'SessionAttendeesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SessionAttendee` at the end of the edge. */
  node?: Maybe<SessionAttendee>;
};

/** Methods to use when ordering `SessionAttendee`. */
export enum SessionAttendeesOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  SessionIdAsc = 'SESSION_ID_ASC',
  SessionIdDesc = 'SESSION_ID_DESC',
  ChangedAtAsc = 'CHANGED_AT_ASC',
  ChangedAtDesc = 'CHANGED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `sessionChatMessageSend` mutation. */
export type SessionChatMessageSendInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  sessionId: Scalars['Int'];
  message: Scalars['String'];
};

/** The output of our `sessionChatMessageSend` mutation. */
export type SessionChatMessageSendPayload = {
  __typename?: 'SessionChatMessageSendPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A condition to be used against `Session` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type SessionCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `presenterId` field. */
  presenterId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `topicId` field. */
  topicId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `topicPublic` field. */
  topicPublic?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `studentPublic` field. */
  studentPublic?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `studentGroupId` field. */
  studentGroupId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `startedAt` field. */
  startedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `stoppedAt` field. */
  stoppedAt?: Maybe<Scalars['Datetime']>;
};

/** A filter to be used against `Session` object types. All fields are combined with a logical ‘and.’ */
export type SessionFilter = {
  /** Filter by the object’s `id` field. */
  id?: Maybe<IntFilter>;
  /** Filter by the object’s `presenterId` field. */
  presenterId?: Maybe<IntFilter>;
  /** Filter by the object’s `topicId` field. */
  topicId?: Maybe<IntFilter>;
  /** Filter by the object’s `studentGroupId` field. */
  studentGroupId?: Maybe<IntFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `startedAt` field. */
  startedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `stoppedAt` field. */
  stoppedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `sessionAttendees` relation. */
  sessionAttendees?: Maybe<SessionToManySessionAttendeeFilter>;
  /** Some related `sessionAttendees` exist. */
  sessionAttendeesExist?: Maybe<Scalars['Boolean']>;
  /** Filter by the object’s `topic` relation. */
  topic?: Maybe<ItemFilter>;
  /** Filter by the object’s `studentGroup` relation. */
  studentGroup?: Maybe<StudentGroupFilter>;
  /** A related `studentGroup` exists. */
  studentGroupExists?: Maybe<Scalars['Boolean']>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<SessionFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<SessionFilter>>;
  /** Negates the expression. */
  not?: Maybe<SessionFilter>;
};

/** An input for mutations affecting `Session` */
export type SessionInput = {
  topicId: Scalars['Int'];
  studentPublic?: Maybe<Scalars['Boolean']>;
  studentGroupId?: Maybe<Scalars['Int']>;
  retakes?: Maybe<Scalars['Int']>;
};

/** Represents an update to a `Session`. Fields that are set will be updated. */
export type SessionPatch = {
  topicPublic?: Maybe<Scalars['Boolean']>;
  signupCode?: Maybe<Scalars['String']>;
  retakes?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  startedAt?: Maybe<Scalars['Datetime']>;
  stoppedAt?: Maybe<Scalars['Datetime']>;
  data?: Maybe<Scalars['JSON']>;
};

/** All input for the `sessionProjectorAuthenticate` mutation. */
export type SessionProjectorAuthenticateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
};

/** The output of our `sessionProjectorAuthenticate` mutation. */
export type SessionProjectorAuthenticatePayload = {
  __typename?: 'SessionProjectorAuthenticatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jwtToken?: Maybe<Scalars['JwtToken']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A filter to be used against many `SessionAttendee` object types. All fields are combined with a logical ‘and.’ */
export type SessionToManySessionAttendeeFilter = {
  /** Every related `SessionAttendee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: Maybe<SessionAttendeeFilter>;
  /** Some related `SessionAttendee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: Maybe<SessionAttendeeFilter>;
  /** No related `SessionAttendee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: Maybe<SessionAttendeeFilter>;
};

/** A connection to a list of `Session` values. */
export type SessionsConnection = {
  __typename?: 'SessionsConnection';
  /** A list of `Session` objects. */
  nodes: Array<Maybe<Session>>;
  /** A list of edges which contains the `Session` and cursor to aid in pagination. */
  edges: Array<SessionsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Session` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Session` edge in the connection. */
export type SessionsEdge = {
  __typename?: 'SessionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Session` at the end of the edge. */
  node?: Maybe<Session>;
};

/** Methods to use when ordering `Session`. */
export enum SessionsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  PresenterIdAsc = 'PRESENTER_ID_ASC',
  PresenterIdDesc = 'PRESENTER_ID_DESC',
  TopicIdAsc = 'TOPIC_ID_ASC',
  TopicIdDesc = 'TOPIC_ID_DESC',
  TopicPublicAsc = 'TOPIC_PUBLIC_ASC',
  TopicPublicDesc = 'TOPIC_PUBLIC_DESC',
  StudentPublicAsc = 'STUDENT_PUBLIC_ASC',
  StudentPublicDesc = 'STUDENT_PUBLIC_DESC',
  StudentGroupIdAsc = 'STUDENT_GROUP_ID_ASC',
  StudentGroupIdDesc = 'STUDENT_GROUP_ID_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  StartedAtAsc = 'STARTED_AT_ASC',
  StartedAtDesc = 'STARTED_AT_DESC',
  StoppedAtAsc = 'STOPPED_AT_ASC',
  StoppedAtDesc = 'STOPPED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: Maybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: Maybe<Scalars['String']>;
  /** Not equal to the specified value. */
  notEqualTo?: Maybe<Scalars['String']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: Maybe<Scalars['String']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: Maybe<Scalars['String']>;
};

export type Student = Node & {
  __typename?: 'Student';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['Int'];
  personId: Scalars['Int'];
  courseId: Scalars['Int'];
  studentGroupId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  blockedAt?: Maybe<Scalars['Datetime']>;
  quittedAt?: Maybe<Scalars['Datetime']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Item` that is related to this `Student`. */
  course?: Maybe<Item>;
  /** Reads a single `StudentGroup` that is related to this `Student`. */
  studentGroup?: Maybe<StudentGroup>;
  contactName?: Maybe<Scalars['String']>;
  publicProfile?: Maybe<PersonPublicProfile>;
  /** Reads and enables pagination through a set of `SessionAttendee`. */
  sessionAttendees: SessionAttendeesConnection;
};


export type StudentSessionAttendeesArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
};

/** A condition to be used against `Student` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type StudentCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `personId` field. */
  personId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `courseId` field. */
  courseId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `studentGroupId` field. */
  studentGroupId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `blockedAt` field. */
  blockedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `quittedAt` field. */
  quittedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: Maybe<Scalars['Datetime']>;
};

/** A filter to be used against `Student` object types. All fields are combined with a logical ‘and.’ */
export type StudentFilter = {
  /** Filter by the object’s `id` field. */
  id?: Maybe<IntFilter>;
  /** Filter by the object’s `personId` field. */
  personId?: Maybe<IntFilter>;
  /** Filter by the object’s `courseId` field. */
  courseId?: Maybe<IntFilter>;
  /** Filter by the object’s `studentGroupId` field. */
  studentGroupId?: Maybe<IntFilter>;
  /** Filter by the object’s `blockedAt` field. */
  blockedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `quittedAt` field. */
  quittedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `course` relation. */
  course?: Maybe<ItemFilter>;
  /** Filter by the object’s `studentGroup` relation. */
  studentGroup?: Maybe<StudentGroupFilter>;
  /** A related `studentGroup` exists. */
  studentGroupExists?: Maybe<Scalars['Boolean']>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<StudentFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<StudentFilter>>;
  /** Negates the expression. */
  not?: Maybe<StudentFilter>;
};

export type StudentGroup = Node & {
  __typename?: 'StudentGroup';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['Int'];
  courseId: Scalars['Int'];
  presenterId: Scalars['Int'];
  signupCode: Scalars['String'];
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  name: Scalars['String'];
  nameSearch: Scalars['String'];
  /** Reads and enables pagination through a set of `Student`. */
  students: StudentsConnection;
  /** Reads and enables pagination through a set of `Session`. */
  sessions: SessionsConnection;
  /** Reads and enables pagination through a set of `ForumTopicStudentGroup`. */
  forumTopicStudentGroupsByStudentGroupIdAndCourseId: ForumTopicStudentGroupsConnection;
  presenterPublicProfile?: Maybe<PersonPublicProfile>;
};


export type StudentGroupStudentsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<StudentsOrderBy>>;
  condition?: Maybe<StudentCondition>;
  filter?: Maybe<StudentFilter>;
};


export type StudentGroupSessionsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<SessionsOrderBy>>;
  condition?: Maybe<SessionCondition>;
  filter?: Maybe<SessionFilter>;
};


export type StudentGroupForumTopicStudentGroupsByStudentGroupIdAndCourseIdArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  after?: Maybe<Scalars['Cursor']>;
  orderBy?: Maybe<Array<ForumTopicStudentGroupsOrderBy>>;
  condition?: Maybe<ForumTopicStudentGroupCondition>;
  filter?: Maybe<ForumTopicStudentGroupFilter>;
};

/**
 * A condition to be used against `StudentGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type StudentGroupCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `courseId` field. */
  courseId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `presenterId` field. */
  presenterId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `nameSearch` field. */
  nameSearch?: Maybe<Scalars['String']>;
};

/** A filter to be used against `StudentGroup` object types. All fields are combined with a logical ‘and.’ */
export type StudentGroupFilter = {
  /** Filter by the object’s `id` field. */
  id?: Maybe<IntFilter>;
  /** Filter by the object’s `courseId` field. */
  courseId?: Maybe<IntFilter>;
  /** Filter by the object’s `presenterId` field. */
  presenterId?: Maybe<IntFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: Maybe<DatetimeFilter>;
  /** Filter by the object’s `nameSearch` field. */
  nameSearch?: Maybe<StringFilter>;
  /** Filter by the object’s `students` relation. */
  students?: Maybe<StudentGroupToManyStudentFilter>;
  /** Some related `students` exist. */
  studentsExist?: Maybe<Scalars['Boolean']>;
  /** Filter by the object’s `sessions` relation. */
  sessions?: Maybe<StudentGroupToManySessionFilter>;
  /** Some related `sessions` exist. */
  sessionsExist?: Maybe<Scalars['Boolean']>;
  /** Filter by the object’s `forumTopicStudentGroupsByStudentGroupIdAndCourseId` relation. */
  forumTopicStudentGroupsByStudentGroupIdAndCourseId?: Maybe<StudentGroupToManyForumTopicStudentGroupFilter>;
  /** Some related `forumTopicStudentGroupsByStudentGroupIdAndCourseId` exist. */
  forumTopicStudentGroupsByStudentGroupIdAndCourseIdExist?: Maybe<Scalars['Boolean']>;
  /** Checks for all expressions in this list. */
  and?: Maybe<Array<StudentGroupFilter>>;
  /** Checks for any expressions in this list. */
  or?: Maybe<Array<StudentGroupFilter>>;
  /** Negates the expression. */
  not?: Maybe<StudentGroupFilter>;
};

/** An input for mutations affecting `StudentGroup` */
export type StudentGroupInput = {
  courseId: Scalars['Int'];
  name: Scalars['String'];
};

/** Represents an update to a `StudentGroup`. Fields that are set will be updated. */
export type StudentGroupPatch = {
  presenterId?: Maybe<Scalars['Int']>;
  signupCode?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  name?: Maybe<Scalars['String']>;
};

/** A filter to be used against many `ForumTopicStudentGroup` object types. All fields are combined with a logical ‘and.’ */
export type StudentGroupToManyForumTopicStudentGroupFilter = {
  /** Every related `ForumTopicStudentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: Maybe<ForumTopicStudentGroupFilter>;
  /** Some related `ForumTopicStudentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: Maybe<ForumTopicStudentGroupFilter>;
  /** No related `ForumTopicStudentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: Maybe<ForumTopicStudentGroupFilter>;
};

/** A filter to be used against many `Session` object types. All fields are combined with a logical ‘and.’ */
export type StudentGroupToManySessionFilter = {
  /** Every related `Session` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: Maybe<SessionFilter>;
  /** Some related `Session` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: Maybe<SessionFilter>;
  /** No related `Session` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: Maybe<SessionFilter>;
};

/** A filter to be used against many `Student` object types. All fields are combined with a logical ‘and.’ */
export type StudentGroupToManyStudentFilter = {
  /** Every related `Student` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: Maybe<StudentFilter>;
  /** Some related `Student` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: Maybe<StudentFilter>;
  /** No related `Student` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: Maybe<StudentFilter>;
};

/** A connection to a list of `StudentGroup` values. */
export type StudentGroupsConnection = {
  __typename?: 'StudentGroupsConnection';
  /** A list of `StudentGroup` objects. */
  nodes: Array<Maybe<StudentGroup>>;
  /** A list of edges which contains the `StudentGroup` and cursor to aid in pagination. */
  edges: Array<StudentGroupsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `StudentGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `StudentGroup` edge in the connection. */
export type StudentGroupsEdge = {
  __typename?: 'StudentGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `StudentGroup` at the end of the edge. */
  node?: Maybe<StudentGroup>;
};

/** Represents an update to a `Student`. Fields that are set will be updated. */
export type StudentPatch = {
  studentGroupId?: Maybe<Scalars['Int']>;
  blockedAt?: Maybe<Scalars['Datetime']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
};

/** All input for the `studentSetContactName` mutation. */
export type StudentSetContactNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  contactPersonId: Scalars['Int'];
  name: Scalars['String'];
};

/** The output of our `studentSetContactName` mutation. */
export type StudentSetContactNamePayload = {
  __typename?: 'StudentSetContactNamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  string?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `Student` values. */
export type StudentsConnection = {
  __typename?: 'StudentsConnection';
  /** A list of `Student` objects. */
  nodes: Array<Maybe<Student>>;
  /** A list of edges which contains the `Student` and cursor to aid in pagination. */
  edges: Array<StudentsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Student` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Student` edge in the connection. */
export type StudentsEdge = {
  __typename?: 'StudentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Student` at the end of the edge. */
  node?: Maybe<Student>;
};

/** Methods to use when ordering `Student`. */
export enum StudentsOrderBy {
  Natural = 'NATURAL',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  PersonIdAsc = 'PERSON_ID_ASC',
  PersonIdDesc = 'PERSON_ID_DESC',
  CourseIdAsc = 'COURSE_ID_ASC',
  CourseIdDesc = 'COURSE_ID_DESC',
  StudentGroupIdAsc = 'STUDENT_GROUP_ID_ASC',
  StudentGroupIdDesc = 'STUDENT_GROUP_ID_DESC',
  BlockedAtAsc = 'BLOCKED_AT_ASC',
  BlockedAtDesc = 'BLOCKED_AT_DESC',
  QuittedAtAsc = 'QUITTED_AT_ASC',
  QuittedAtDesc = 'QUITTED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription';
  messenger: SubscriptionMessengerPayload;
  item: SubscriptionItemPayload;
  session: SubscriptionSessionPayload;
  sessionAttendees: SubscriptionSessionAttendeesPayload;
  attendeeResponse: SubscriptionAttendeeResponsePayload;
  attendeeSession: SubscriptionAttendeeSessionPayload;
  attendeeTopic: SubscriptionAttendeeTopicPayload;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionItemArgs = {
  itemId: Scalars['Int'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionSessionArgs = {
  sessionId: Scalars['Int'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionSessionAttendeesArgs = {
  sessionId: Scalars['Int'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionAttendeeResponseArgs = {
  attendeeId: Scalars['UUID'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionAttendeeSessionArgs = {
  attendeeId: Scalars['UUID'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionAttendeeTopicArgs = {
  attendeeId: Scalars['UUID'];
};

export type SubscriptionAttendeeResponsePayload = {
  __typename?: 'SubscriptionAttendeeResponsePayload';
  init?: Maybe<SessionAttendee>;
  payload?: Maybe<SubscriptionPayload>;
};

export type SubscriptionAttendeeSessionPayload = {
  __typename?: 'SubscriptionAttendeeSessionPayload';
  init?: Maybe<Session>;
  payload?: Maybe<SubscriptionPayload>;
};

export type SubscriptionAttendeeTopicPayload = {
  __typename?: 'SubscriptionAttendeeTopicPayload';
  init?: Maybe<Item>;
  payload?: Maybe<SubscriptionPayload>;
};

export type SubscriptionItemPayload = {
  __typename?: 'SubscriptionItemPayload';
  init?: Maybe<Item>;
  payload?: Maybe<SubscriptionPayload>;
};

export type SubscriptionMessengerPayload = {
  __typename?: 'SubscriptionMessengerPayload';
  init?: Maybe<Scalars['Boolean']>;
  messengerActivity?: Maybe<MessengerActivity>;
  payload?: Maybe<SubscriptionPayload>;
};

export type SubscriptionPayload = Node & {
  __typename?: 'SubscriptionPayload';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  data: Scalars['JSON'];
};

export type SubscriptionSessionAttendeesPayload = {
  __typename?: 'SubscriptionSessionAttendeesPayload';
  init?: Maybe<Array<SessionAttendee>>;
  sessionAttendee?: Maybe<SessionAttendee>;
  payload?: Maybe<SubscriptionPayload>;
};

export type SubscriptionSessionPayload = {
  __typename?: 'SubscriptionSessionPayload';
  init?: Maybe<Session>;
  payload?: Maybe<SubscriptionPayload>;
};

/** All input for the `trashEmpty` mutation. */
export type TrashEmptyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** The output of our `trashEmpty` mutation. */
export type TrashEmptyPayload = {
  __typename?: 'TrashEmptyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** All input for the `updateAttendeeResponseAndSessionStats` mutation. */
export type UpdateAttendeeResponseAndSessionStatsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  attendeeId?: Maybe<Scalars['UUID']>;
  slideId?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['JSON']>;
};

/** The output of our `updateAttendeeResponseAndSessionStats` mutation. */
export type UpdateAttendeeResponseAndSessionStatsPayload = {
  __typename?: 'UpdateAttendeeResponseAndSessionStatsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['JSON']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateAttendeeResponseFinish` mutation. */
export type UpdateAttendeeResponseFinishInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  attendeeId: Scalars['UUID'];
};

/** The output of our `updateAttendeeResponseFinish` mutation. */
export type UpdateAttendeeResponseFinishPayload = {
  __typename?: 'UpdateAttendeeResponseFinishPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['JSON']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateAttendeeResponse` mutation. */
export type UpdateAttendeeResponseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  attendeeId?: Maybe<Scalars['UUID']>;
  slideId?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['JSON']>;
};

/** All input for the `updateAttendeeResponseMeta` mutation. */
export type UpdateAttendeeResponseMetaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  attendeeId: Scalars['UUID'];
  meta: Scalars['JSON'];
};

/** The output of our `updateAttendeeResponseMeta` mutation. */
export type UpdateAttendeeResponseMetaPayload = {
  __typename?: 'UpdateAttendeeResponseMetaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateAttendeeResponseNext` mutation. */
export type UpdateAttendeeResponseNextInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  attendeeId: Scalars['UUID'];
  nextSlideId: Scalars['String'];
};

/** The output of our `updateAttendeeResponseNext` mutation. */
export type UpdateAttendeeResponseNextPayload = {
  __typename?: 'UpdateAttendeeResponseNextPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['JSON']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `updateAttendeeResponse` mutation. */
export type UpdateAttendeeResponsePayload = {
  __typename?: 'UpdateAttendeeResponsePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['JSON']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateAttendeeResponseSlideMeta` mutation. */
export type UpdateAttendeeResponseSlideMetaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  attendeeId: Scalars['UUID'];
  slideId: Scalars['String'];
  meta: Scalars['JSON'];
};

/** The output of our `updateAttendeeResponseSlideMeta` mutation. */
export type UpdateAttendeeResponseSlideMetaPayload = {
  __typename?: 'UpdateAttendeeResponseSlideMetaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateAttendeeResponseStart` mutation. */
export type UpdateAttendeeResponseStartInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  attendeeId: Scalars['UUID'];
};

/** The output of our `updateAttendeeResponseStart` mutation. */
export type UpdateAttendeeResponseStartPayload = {
  __typename?: 'UpdateAttendeeResponseStartPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateContactByNodeId` mutation. */
export type UpdateContactByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Contact` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Contact` being updated. */
  patch: ContactPatch;
};

/** All input for the `updateContactByPersonIdAndContactEmailHash` mutation. */
export type UpdateContactByPersonIdAndContactEmailHashInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Contact` being updated. */
  patch: ContactPatch;
  personId: Scalars['Int'];
  contactEmailHash: Scalars['String'];
};

/** All input for the `updateContactByPersonIdAndContactPersonId` mutation. */
export type UpdateContactByPersonIdAndContactPersonIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Contact` being updated. */
  patch: ContactPatch;
  personId: Scalars['Int'];
  contactPersonId: Scalars['Int'];
};

/** All input for the `updateContactGroupByNodeId` mutation. */
export type UpdateContactGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ContactGroup` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ContactGroup` being updated. */
  patch: ContactGroupPatch;
};

/** All input for the `updateContactGroupByPersonIdAndName` mutation. */
export type UpdateContactGroupByPersonIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ContactGroup` being updated. */
  patch: ContactGroupPatch;
  personId: Scalars['Int'];
  name: Scalars['String'];
};

/** All input for the `updateContactGroup` mutation. */
export type UpdateContactGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ContactGroup` being updated. */
  patch: ContactGroupPatch;
  id: Scalars['Int'];
};

/** The output of our update `ContactGroup` mutation. */
export type UpdateContactGroupPayload = {
  __typename?: 'UpdateContactGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ContactGroup` that was updated by this mutation. */
  contactGroup?: Maybe<ContactGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Person` that is related to this `ContactGroup`. */
  person?: Maybe<Person>;
  /** An edge for our `ContactGroup`. May be used by Relay 1. */
  contactGroupEdge?: Maybe<ContactGroupsEdge>;
};


/** The output of our update `ContactGroup` mutation. */
export type UpdateContactGroupPayloadContactGroupEdgeArgs = {
  orderBy?: Maybe<Array<ContactGroupsOrderBy>>;
};

/** All input for the `updateContact` mutation. */
export type UpdateContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Contact` being updated. */
  patch: ContactPatch;
  id: Scalars['Int'];
};

/** The output of our update `Contact` mutation. */
export type UpdateContactPayload = {
  __typename?: 'UpdateContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Contact` that was updated by this mutation. */
  contact?: Maybe<Contact>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Person` that is related to this `Contact`. */
  person?: Maybe<Person>;
  /** An edge for our `Contact`. May be used by Relay 1. */
  contactEdge?: Maybe<ContactsEdge>;
};


/** The output of our update `Contact` mutation. */
export type UpdateContactPayloadContactEdgeArgs = {
  orderBy?: Maybe<Array<ContactsOrderBy>>;
};

/** All input for the `updateForumPersonActivity` mutation. */
export type UpdateForumPersonActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  forumTopicId: Scalars['Int'];
  lastPostId: Scalars['Int'];
};

/** The output of our `updateForumPersonActivity` mutation. */
export type UpdateForumPersonActivityPayload = {
  __typename?: 'UpdateForumPersonActivityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateForumTopicByIdAndCourseId` mutation. */
export type UpdateForumTopicByIdAndCourseIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ForumTopic` being updated. */
  patch: ForumTopicPatch;
  id: Scalars['Int'];
  courseId: Scalars['Int'];
};

/** All input for the `updateForumTopicByNodeId` mutation. */
export type UpdateForumTopicByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ForumTopic` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ForumTopic` being updated. */
  patch: ForumTopicPatch;
};

/** All input for the `updateForumTopic` mutation. */
export type UpdateForumTopicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ForumTopic` being updated. */
  patch: ForumTopicPatch;
  id: Scalars['Int'];
};

/** The output of our update `ForumTopic` mutation. */
export type UpdateForumTopicPayload = {
  __typename?: 'UpdateForumTopicPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ForumTopic` that was updated by this mutation. */
  forumTopic?: Maybe<ForumTopic>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `ForumTopic`. */
  course?: Maybe<Item>;
  /** An edge for our `ForumTopic`. May be used by Relay 1. */
  forumTopicEdge?: Maybe<ForumTopicsEdge>;
};


/** The output of our update `ForumTopic` mutation. */
export type UpdateForumTopicPayloadForumTopicEdgeArgs = {
  orderBy?: Maybe<Array<ForumTopicsOrderBy>>;
};

/** All input for the `updateItemByNodeId` mutation. */
export type UpdateItemByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Item` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Item` being updated. */
  patch: ItemPatch;
};

/** All input for the `updateItemCourseTopicMove` mutation. */
export type UpdateItemCourseTopicMoveInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  topicPath: Scalars['String'];
  index: Scalars['Int'];
};

/** The output of our `updateItemCourseTopicMove` mutation. */
export type UpdateItemCourseTopicMovePayload = {
  __typename?: 'UpdateItemCourseTopicMovePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['JSON']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateItemData` mutation. */
export type UpdateItemDataInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  data: Scalars['JSON'];
};

/** The output of our `updateItemData` mutation. */
export type UpdateItemDataPayload = {
  __typename?: 'UpdateItemDataPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateItem` mutation. */
export type UpdateItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Item` being updated. */
  patch: ItemPatch;
  id: Scalars['Int'];
};

/** All input for the `updateItemMove` mutation. */
export type UpdateItemMoveInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  parentId: Scalars['Int'];
};

/** The output of our `updateItemMove` mutation. */
export type UpdateItemMovePayload = {
  __typename?: 'UpdateItemMovePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  item?: Maybe<Item>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `Item`. */
  course?: Maybe<Item>;
  /** An edge for our `Item`. May be used by Relay 1. */
  itemEdge?: Maybe<ItemsEdge>;
};


/** The output of our `updateItemMove` mutation. */
export type UpdateItemMovePayloadItemEdgeArgs = {
  orderBy?: Maybe<Array<ItemsOrderBy>>;
};

/** The output of our update `Item` mutation. */
export type UpdateItemPayload = {
  __typename?: 'UpdateItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Item` that was updated by this mutation. */
  item?: Maybe<Item>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `Item`. */
  course?: Maybe<Item>;
  /** An edge for our `Item`. May be used by Relay 1. */
  itemEdge?: Maybe<ItemsEdge>;
};


/** The output of our update `Item` mutation. */
export type UpdateItemPayloadItemEdgeArgs = {
  orderBy?: Maybe<Array<ItemsOrderBy>>;
};

/** All input for the `updateItemShareByPathAndPersonId` mutation. */
export type UpdateItemShareByPathAndPersonIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ItemShare` being updated. */
  patch: ItemSharePatch;
  path: Scalars['String'];
  personId: Scalars['Int'];
};

/** The output of our update `ItemShare` mutation. */
export type UpdateItemSharePayload = {
  __typename?: 'UpdateItemSharePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ItemShare` that was updated by this mutation. */
  itemShare?: Maybe<ItemShare>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `ItemShare`. */
  itemByPath?: Maybe<Item>;
  /** Reads a single `Person` that is related to this `ItemShare`. */
  person?: Maybe<Person>;
  /** An edge for our `ItemShare`. May be used by Relay 1. */
  itemShareEdge?: Maybe<ItemSharesEdge>;
};

/** All input for the `updatePersonByNodeId` mutation. */
export type UpdatePersonByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Person` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Person` being updated. */
  patch: PersonPatch;
};

/** All input for the `updatePerson` mutation. */
export type UpdatePersonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Person` being updated. */
  patch: PersonPatch;
  id: Scalars['Int'];
};

/** The output of our update `Person` mutation. */
export type UpdatePersonPayload = {
  __typename?: 'UpdatePersonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Person` that was updated by this mutation. */
  person?: Maybe<Person>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `Person`. May be used by Relay 1. */
  personEdge?: Maybe<PeopleEdge>;
};

/** All input for the `updateSessionByNodeId` mutation. */
export type UpdateSessionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Session` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Session` being updated. */
  patch: SessionPatch;
};

/** All input for the `updateSession` mutation. */
export type UpdateSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Session` being updated. */
  patch: SessionPatch;
  id: Scalars['Int'];
};

/** The output of our update `Session` mutation. */
export type UpdateSessionPayload = {
  __typename?: 'UpdateSessionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Session` that was updated by this mutation. */
  session?: Maybe<Session>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `Session`. */
  topic?: Maybe<Item>;
  /** Reads a single `StudentGroup` that is related to this `Session`. */
  studentGroup?: Maybe<StudentGroup>;
  /** An edge for our `Session`. May be used by Relay 1. */
  sessionEdge?: Maybe<SessionsEdge>;
};


/** The output of our update `Session` mutation. */
export type UpdateSessionPayloadSessionEdgeArgs = {
  orderBy?: Maybe<Array<SessionsOrderBy>>;
};

/** All input for the `updateStudentByNodeId` mutation. */
export type UpdateStudentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Student` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Student` being updated. */
  patch: StudentPatch;
};

/** All input for the `updateStudentGroupByCourseIdAndId` mutation. */
export type UpdateStudentGroupByCourseIdAndIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `StudentGroup` being updated. */
  patch: StudentGroupPatch;
  courseId: Scalars['Int'];
  id: Scalars['Int'];
};

/** All input for the `updateStudentGroupByNodeId` mutation. */
export type UpdateStudentGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `StudentGroup` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `StudentGroup` being updated. */
  patch: StudentGroupPatch;
};

/** All input for the `updateStudentGroup` mutation. */
export type UpdateStudentGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `StudentGroup` being updated. */
  patch: StudentGroupPatch;
  id: Scalars['Int'];
};

/** The output of our update `StudentGroup` mutation. */
export type UpdateStudentGroupPayload = {
  __typename?: 'UpdateStudentGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `StudentGroup` that was updated by this mutation. */
  studentGroup?: Maybe<StudentGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `StudentGroup`. May be used by Relay 1. */
  studentGroupEdge?: Maybe<StudentGroupsEdge>;
};

/** All input for the `updateStudent` mutation. */
export type UpdateStudentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Student` being updated. */
  patch: StudentPatch;
  id: Scalars['Int'];
};

/** The output of our update `Student` mutation. */
export type UpdateStudentPayload = {
  __typename?: 'UpdateStudentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Student` that was updated by this mutation. */
  student?: Maybe<Student>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Item` that is related to this `Student`. */
  course?: Maybe<Item>;
  /** Reads a single `StudentGroup` that is related to this `Student`. */
  studentGroup?: Maybe<StudentGroup>;
  /** An edge for our `Student`. May be used by Relay 1. */
  studentEdge?: Maybe<StudentsEdge>;
};


/** The output of our update `Student` mutation. */
export type UpdateStudentPayloadStudentEdgeArgs = {
  orderBy?: Maybe<Array<StudentsOrderBy>>;
};

export type Upload = Node & {
  __typename?: 'Upload';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  id: Scalars['Int'];
  size: Scalars['Int'];
  type: Scalars['String'];
  src: Scalars['String'];
  complete: Scalars['Boolean'];
  createdAt: Scalars['Datetime'];
};
